/* Twelveboards Gift Card Wizard
 * URL-driven seven-step purchase flow.
 * Single instance per page. Vanilla, no deps.
 */
(function () {
  'use strict';

  var TB = window.TB = window.TB || {};

  // ----- Constants -----
  var STEPS = 7;
  var DEFAULTS = {
    step:'1', to:'', from:'', self:'0', event:'', design:'',
    amount:'', qty:'1', msg:'', email:'', emailConfirm:'', date:''
  };
  var ALLOWED_EVENTS = ['birthday','christmas','just-because','thanks','apology','other'];
  var EVENT_NAMES = {
    'birthday': 'Birthday',
    'christmas': 'Christmas',
    'just-because': 'Just because',
    'thanks': 'Thanks',
    'apology': 'Apology',
    'other': 'Other'
  };
  var SUGGESTIONS = {
    'birthday': [
      "Happy birthday — go pick something good.",
      "Stoked for ya. Birthday on the board.",
      "Another year. New deck on me."
    ],
    'christmas': [
      "Merry Christmas — ride hard, ride often.",
      "Happy holidays. Treat yourself.",
      "Found this under the tree."
    ],
    'just-because': [
      "Saw this and thought of you.",
      "Just because. Enjoy.",
      "No occasion needed. Go ride."
    ],
    'thanks': [
      "Thanks for everything. Owe you one.",
      "You're a legend. Cheers.",
      "Couldn't have done it without you."
    ],
    'apology': [
      "Sorry — I owe you this and more.",
      "My bad. Make it up to you.",
      "Forgive me. Treat yourself on me."
    ],
    'other': [
      "Hope you love it.",
      "Enjoy. You earned it.",
      "Ride safe. Have fun."
    ]
  };
  var CTA_LABELS = {
    1: "What's the occasion? →",
    2: 'Pick a gift card →',
    3: 'How much? →',
    4: 'Add a message →',
    5: 'Where is it going? →',
    6: 'Add to bag →',
    7: '' // step 7 is dynamic
  };
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  var MAX_QTY = 20;
  var MIN_QTY = 1;
  var MSG_MAX = 250;
  var DATE_MAX_DAYS = 90;
  var MAX_UPLOAD_BYTES = 4 * 1024 * 1024; // 4MB
  var ACCEPTED_UPLOAD_TYPES = ['image/png','image/jpeg','image/webp'];

  // ----- Emoji bank -----
  // Hand-curated for gift-card sentiments. Heavy on Activities (board sports)
  // since this is Twelveboards. Each entry: { char, name, category }.
  // `name` is space-separated lowercase keywords used by the search filter.
  var EMOJI_CATEGORIES = [
    { id: 'hot',         label: 'Hot' },
    { id: 'all',         label: 'All' },
    { id: 'smileys',     label: 'Smileys' },
    { id: 'hearts',      label: 'Hearts' },
    { id: 'animals',     label: 'Animals' },
    { id: 'food',        label: 'Food' },
    { id: 'activities',  label: 'Activities' },
    { id: 'travel',      label: 'Travel' },
    { id: 'symbols',     label: 'Symbols' }
  ];
  // Curated "Hot" set — ~22 most universal/relatable emojis, ordered for the
  // ~11-column grid (about 2 visible rows). All chars must exist in EMOJI_BANK
  // so search-text metadata stays consistent. Order is preserved at render.
  var EMOJI_HOT = [
    '😀','😄','😂','😍','🥰','😘','😎','🤩','🥳','🤗','🙂',
    '❤️','🔥','✨','⚡','🎉','🎁','🎂','🛹','🏂','🏄','❄️'
  ];
  var PRODUCT_SUGGESTIONS = {
    skateboard: 'skateboard',
    snowboard: 'snowboard',
    surfboard: 'surfboard',
    longboard: 'longboard',
    helmet: 'helmet',
    bindings: 'bindings'
  };
  var BG_CATEGORIES = ['all','snow','skate','long','electric','soft'];

  var EMOJI_BANK = [
    // Smileys (25)
    { char: '😀', name: 'grinning face happy', category: 'smileys' },
    { char: '😃', name: 'smiling face open mouth', category: 'smileys' },
    { char: '😄', name: 'beaming face happy', category: 'smileys' },
    { char: '😁', name: 'grinning face smiling eyes', category: 'smileys' },
    { char: '😆', name: 'laughing face', category: 'smileys' },
    { char: '😂', name: 'tears of joy crying laughing', category: 'smileys' },
    { char: '🤣', name: 'rolling on the floor laughing', category: 'smileys' },
    { char: '😊', name: 'smiling blushing happy', category: 'smileys' },
    { char: '😇', name: 'smiling halo angel', category: 'smileys' },
    { char: '🙂', name: 'slightly smiling face', category: 'smileys' },
    { char: '😉', name: 'winking face', category: 'smileys' },
    { char: '😍', name: 'heart eyes love', category: 'smileys' },
    { char: '🥰', name: 'smiling hearts in love', category: 'smileys' },
    { char: '😘', name: 'kiss blowing kiss', category: 'smileys' },
    { char: '😋', name: 'yum tasty tongue', category: 'smileys' },
    { char: '😎', name: 'cool sunglasses', category: 'smileys' },
    { char: '🤩', name: 'star struck excited', category: 'smileys' },
    { char: '🥳', name: 'partying face party hat', category: 'smileys' },
    { char: '🤗', name: 'hugging face hug', category: 'smileys' },
    { char: '🤔', name: 'thinking face', category: 'smileys' },
    { char: '😴', name: 'sleeping zzz tired', category: 'smileys' },
    { char: '🥺', name: 'pleading puppy eyes', category: 'smileys' },
    { char: '😭', name: 'crying loud sad tears', category: 'smileys' },
    { char: '🙃', name: 'upside down face', category: 'smileys' },
    { char: '🤙', name: 'shaka call me hang loose', category: 'smileys' },
    { char: '👍', name: 'thumbs up like good', category: 'smileys' },
    { char: '🙌', name: 'raising hands celebrate praise', category: 'smileys' },
    { char: '👏', name: 'clapping hands applause', category: 'smileys' },
    // Hearts (12)
    { char: '❤️', name: 'red heart love', category: 'hearts' },
    { char: '🧡', name: 'orange heart', category: 'hearts' },
    { char: '💛', name: 'yellow heart', category: 'hearts' },
    { char: '💚', name: 'green heart', category: 'hearts' },
    { char: '💙', name: 'blue heart', category: 'hearts' },
    { char: '💜', name: 'purple heart', category: 'hearts' },
    { char: '🖤', name: 'black heart', category: 'hearts' },
    { char: '🤍', name: 'white heart', category: 'hearts' },
    { char: '💖', name: 'sparkling heart shiny', category: 'hearts' },
    { char: '💕', name: 'two hearts pink love', category: 'hearts' },
    { char: '💘', name: 'heart with arrow cupid', category: 'hearts' },
    { char: '❣️', name: 'heart exclamation', category: 'hearts' },
    { char: '💝', name: 'heart with ribbon gift', category: 'hearts' },
    { char: '💗', name: 'growing heart', category: 'hearts' },
    { char: '💞', name: 'revolving hearts', category: 'hearts' },
    // Animals (15)
    { char: '🐶', name: 'dog face puppy', category: 'animals' },
    { char: '🐱', name: 'cat face kitten', category: 'animals' },
    { char: '🦊', name: 'fox face', category: 'animals' },
    { char: '🐻', name: 'bear face', category: 'animals' },
    { char: '🐼', name: 'panda', category: 'animals' },
    { char: '🐨', name: 'koala', category: 'animals' },
    { char: '🐯', name: 'tiger face', category: 'animals' },
    { char: '🦁', name: 'lion face', category: 'animals' },
    { char: '🐸', name: 'frog face', category: 'animals' },
    { char: '🦅', name: 'eagle bird', category: 'animals' },
    { char: '🦉', name: 'owl bird', category: 'animals' },
    { char: '🐢', name: 'turtle', category: 'animals' },
    { char: '🐬', name: 'dolphin sea', category: 'animals' },
    { char: '🦈', name: 'shark sea', category: 'animals' },
    { char: '🦋', name: 'butterfly', category: 'animals' },
    { char: '🐉', name: 'dragon', category: 'animals' },
    { char: '🦄', name: 'unicorn', category: 'animals' },
    { char: '🐝', name: 'bee honey', category: 'animals' },
    // Food (20)
    { char: '🍰', name: 'cake birthday slice', category: 'food' },
    { char: '🎂', name: 'birthday cake candles', category: 'food' },
    { char: '🧁', name: 'cupcake', category: 'food' },
    { char: '🍩', name: 'donut doughnut', category: 'food' },
    { char: '🍪', name: 'cookie', category: 'food' },
    { char: '🍫', name: 'chocolate bar', category: 'food' },
    { char: '🍭', name: 'lollipop candy', category: 'food' },
    { char: '🍬', name: 'candy sweet', category: 'food' },
    { char: '🍦', name: 'ice cream soft serve', category: 'food' },
    { char: '🍕', name: 'pizza slice', category: 'food' },
    { char: '🍔', name: 'burger hamburger', category: 'food' },
    { char: '🌮', name: 'taco mexican', category: 'food' },
    { char: '🍿', name: 'popcorn movie', category: 'food' },
    { char: '🍻', name: 'clinking beer mugs cheers', category: 'food' },
    { char: '🥂', name: 'champagne clinking glasses cheers', category: 'food' },
    { char: '🍾', name: 'champagne bottle pop', category: 'food' },
    { char: '☕', name: 'coffee hot drink', category: 'food' },
    { char: '🍓', name: 'strawberry fruit', category: 'food' },
    { char: '🍎', name: 'red apple fruit', category: 'food' },
    { char: '🍉', name: 'watermelon fruit', category: 'food' },
    // Activities — heavy on board sports (18)
    { char: '🛹', name: 'skateboard skate skateboarding', category: 'activities' },
    { char: '🏂', name: 'snowboard snowboarder snowboarding', category: 'activities' },
    { char: '🏄', name: 'surfer surfing wave', category: 'activities' },
    { char: '🏄‍♀️', name: 'surfer woman surfing wave', category: 'activities' },
    { char: '⛷️', name: 'skier skiing snow', category: 'activities' },
    { char: '🎿', name: 'skis skiing snow', category: 'activities' },
    { char: '🛼', name: 'roller skate skating', category: 'activities' },
    { char: '🛷', name: 'sled sledding snow', category: 'activities' },
    { char: '⛸️', name: 'ice skate skating', category: 'activities' },
    { char: '🥇', name: 'gold medal first place', category: 'activities' },
    { char: '🏆', name: 'trophy winner', category: 'activities' },
    { char: '🎯', name: 'bullseye dart target', category: 'activities' },
    { char: '🎮', name: 'video game controller gaming', category: 'activities' },
    { char: '🎸', name: 'guitar music', category: 'activities' },
    { char: '🎧', name: 'headphones music', category: 'activities' },
    { char: '🎵', name: 'music note', category: 'activities' },
    { char: '🎉', name: 'party popper celebrate', category: 'activities' },
    { char: '🎊', name: 'confetti ball celebrate', category: 'activities' },
    // Travel/Places (15)
    { char: '🏔️', name: 'mountain snowy snow', category: 'travel' },
    { char: '⛰️', name: 'mountain', category: 'travel' },
    { char: '🌋', name: 'volcano', category: 'travel' },
    { char: '🏕️', name: 'camping tent', category: 'travel' },
    { char: '🏖️', name: 'beach umbrella sand', category: 'travel' },
    { char: '🏝️', name: 'desert island palm', category: 'travel' },
    { char: '🌅', name: 'sunrise sunset', category: 'travel' },
    { char: '🌄', name: 'sunrise mountains', category: 'travel' },
    { char: '🌇', name: 'sunset city', category: 'travel' },
    { char: '🌆', name: 'cityscape dusk', category: 'travel' },
    { char: '🗻', name: 'mount fuji', category: 'travel' },
    { char: '🌍', name: 'earth globe world', category: 'travel' },
    { char: '✈️', name: 'airplane plane fly', category: 'travel' },
    { char: '🚗', name: 'car automobile', category: 'travel' },
    { char: '🚀', name: 'rocket launch space', category: 'travel' },
    // Symbols (25)
    { char: '⭐', name: 'star', category: 'symbols' },
    { char: '🌟', name: 'glowing star sparkle', category: 'symbols' },
    { char: '✨', name: 'sparkles shiny', category: 'symbols' },
    { char: '💫', name: 'dizzy star', category: 'symbols' },
    { char: '🔥', name: 'fire flame hot', category: 'symbols' },
    { char: '⚡', name: 'lightning electric high voltage', category: 'symbols' },
    { char: '❄️', name: 'snowflake snow cold', category: 'symbols' },
    { char: '☃️', name: 'snowman snow', category: 'symbols' },
    { char: '⛄', name: 'snowman without snow snowman', category: 'symbols' },
    { char: '🌨️', name: 'cloud with snow snowy', category: 'symbols' },
    { char: '☀️', name: 'sun sunny', category: 'symbols' },
    { char: '🌈', name: 'rainbow', category: 'symbols' },
    { char: '🌙', name: 'crescent moon', category: 'symbols' },
    { char: '☁️', name: 'cloud cloudy', category: 'symbols' },
    { char: '💎', name: 'diamond gem', category: 'symbols' },
    { char: '🎁', name: 'gift wrapped present', category: 'symbols' },
    { char: '🎈', name: 'balloon birthday', category: 'symbols' },
    { char: '🎀', name: 'ribbon bow', category: 'symbols' },
    { char: '👑', name: 'crown king queen', category: 'symbols' },
    { char: '💯', name: 'hundred points perfect', category: 'symbols' },
    { char: '✅', name: 'check mark tick yes', category: 'symbols' },
    { char: '🆗', name: 'ok button', category: 'symbols' },
    { char: '☮️', name: 'peace symbol', category: 'symbols' },
    { char: '☯️', name: 'yin yang', category: 'symbols' },
    { char: '♥️', name: 'heart suit', category: 'symbols' },
    { char: '💥', name: 'collision boom', category: 'symbols' },
    { char: '💨', name: 'dashing wind smoke speed', category: 'symbols' },
    { char: '🌀', name: 'cyclone spiral', category: 'symbols' }
  ];

  // ----- Singletons populated at init -----
  var root, panel, cardEl, ctaEl, errorEl, progressEl;
  var variantData = [];
  var designData = [];
  var designerBgData = [];
  var initialData = { customer_email: '', shop_currency: 'AUD', money_format: '${{amount}}', storefront_token: '', storefront_api_version: '2025-01' };
  var currentStep = 0;
  var lastAnnounce = 0;
  var inflight = false;
  var uploadedFile = null;
  var uploadedDataUrl = '';
  var composerBgUploadDataUrl = '';

  // ----- Composer state -----
  var composer = {
    open: false,
    type: '',
    backgroundId: '',
    bgCategory: 'all',
    emojis: [],    // { id, char, x, y, scale, rotate, _el }
    products: [],  // { handle, image, processedDataUrl, removeWhite, mask, rotate, title, x, y, scale, _el }
    selectedLayer: null,  // currently selected layer item (emoji or product)
    emojiCategory: 'hot',
    emojiSearch: '',
    drawingDataUrl: ''
  };
  var SHAPE_MASKS = {
    square:  'none',
    circle:  'circle(50%)',
    rounded: 'inset(0 round 12% / 18%)',
    hexagon: 'polygon(25% 0%, 75% 0%, 100% 50%, 75% 100%, 25% 100%, 0% 50%)',
    star:    'polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%)'
  };
  var generatedDataUrl = null;
  var generatedFile = null;
  var productSearchTimer = null;
  var COMPOSER_STORAGE_KEY = 'gcw-composer-state';
  var CARD_RENDER_W = 1600;
  var CARD_RENDER_H = 1600;
  // Resize affordance: layer DOM base sizes (1.0 scale).
  var BASE_PX = 120;        // product <img> width at scale 1
  var BASE_FONT_PX = 64;    // emoji <span> font-size at scale 1
  var SCALE_MIN = 0.25;
  var SCALE_MAX = 4.0;

  // ----- State helpers -----
  TB.getState = function () {
    var p = new URLSearchParams(location.search);
    var s = {};
    Object.keys(DEFAULTS).forEach(function (k) {
      s[k] = p.has(k) ? p.get(k) : DEFAULTS[k];
    });
    // Sanitize
    // design is empty, 'custom', 'designer', or a known block id rendered on the page
    if (s.design && s.design !== 'custom' && s.design !== 'designer') {
      var validDesignId = false;
      for (var di = 0; di < designData.length; di++) {
        if (designData[di].id === s.design) { validDesignId = true; break; }
      }
      if (!validDesignId) s.design = '';
    }
    if (s.event && ALLOWED_EVENTS.indexOf(s.event) === -1) s.event = '';
    if (s.self !== '1') s.self = '0';
    var q = parseInt(s.qty, 10);
    if (!q || q < MIN_QTY) q = 1;
    if (q > MAX_QTY) q = MAX_QTY;
    s.qty = String(q);
    var st = parseInt(s.step, 10);
    if (!st || st < 1) st = 1;
    if (st > STEPS) st = STEPS;
    s.step = String(st);
    if (s.msg && s.msg.length > MSG_MAX) s.msg = s.msg.slice(0, MSG_MAX);
    // Validate amount against variants if present
    if (s.amount) {
      var match = variantData.some(function (v) { return String(v.amount) === String(s.amount); });
      if (!match && variantData.length) s.amount = '';
    }
    return s;
  };

  TB.buildUrl = function (patch) {
    var s = TB.getState();
    Object.keys(patch || {}).forEach(function (k) { s[k] = patch[k]; });
    var p = new URLSearchParams();
    Object.keys(DEFAULTS).forEach(function (k) {
      if (s[k] && s[k] !== DEFAULTS[k]) p.set(k, s[k]);
    });
    var qs = p.toString();
    return location.pathname + (qs ? '?' + qs : '');
  };

  TB.go = function (patch, opts) {
    var url = TB.buildUrl(patch || {});
    if (opts && opts.replace) {
      history.replaceState({}, '', url);
    } else {
      history.pushState({}, '', url);
    }
    TB.render();
  };

  TB.fmtAUD = function (n) {
    var v = Number(n || 0);
    if (!isFinite(v)) v = 0;
    return '$' + Math.round(v).toLocaleString('en-AU');
  };

  TB.escapeHTML = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c];
    });
  };

  // ----- Variant matching -----
  function variantForAmount(amount) {
    if (!amount) return null;
    for (var i = 0; i < variantData.length; i++) {
      if (String(variantData[i].amount) === String(amount)) return variantData[i];
    }
    return null;
  }
  function defaultAmount() {
    if (!variantData.length) return '';
    // Prefer 100, else first available
    var hundred = variantForAmount(100);
    if (hundred) return String(hundred.amount);
    return String(variantData[0].amount);
  }

  // ----- Design lookup -----
  function designForId(id) {
    if (!id) return null;
    if (id === 'custom') {
      return { id: 'custom', label: 'Custom upload', image: uploadedDataUrl };
    }
    if (id === 'designer') {
      return { id: 'designer', label: 'Custom designer composition', image: generatedDataUrl || '' };
    }
    for (var i = 0; i < designData.length; i++) {
      if (designData[i].id === id) return designData[i];
    }
    return null;
  }
  function designerBgForId(id) {
    for (var i = 0; i < designerBgData.length; i++) {
      if (designerBgData[i].id === id) return designerBgData[i];
    }
    return null;
  }

  // ----- Card preview render (no rebuild, just text/attr updates) -----
  TB.renderCard = function (state) {
    if (!cardEl) return;
    var s = state || TB.getState();
    var design = designForId(s.design);

    // Background image: chosen design's image OR uploaded data URL OR none.
    var bgEl = cardEl.querySelector('[data-gcw-card-bg]');
    if (bgEl) {
      var bgUrl = design && design.image ? design.image : '';
      if (bgUrl) {
        if (bgEl.getAttribute('src') !== bgUrl) bgEl.setAttribute('src', bgUrl);
        bgEl.hidden = false;
      } else {
        // Fall back to default image rendered server-side, if any.
        var defaultSrc = bgEl.getAttribute('data-default-src') || '';
        if (!defaultSrc && bgEl.getAttribute('src')) {
          // Capture the server-rendered default once for later restore.
          bgEl.setAttribute('data-default-src', bgEl.getAttribute('src'));
          defaultSrc = bgEl.getAttribute('src');
        }
        if (defaultSrc) {
          if (bgEl.getAttribute('src') !== defaultSrc) bgEl.setAttribute('src', defaultSrc);
          bgEl.hidden = false;
        } else {
          bgEl.removeAttribute('src');
          bgEl.hidden = true;
        }
      }
    }

    // FROM overlay: show "FROM {NAME}" when sender provided AND it's a gift
    // (not self-purchase). Hidden otherwise.
    var fromEl = cardEl.querySelector('[data-card-from]');
    if (fromEl) {
      var showFrom = s.from && s.from.trim() && s.self !== '1';
      if (showFrom) {
        fromEl.textContent = 'FROM ' + s.from.trim().toUpperCase();
        fromEl.hidden = false;
      } else {
        fromEl.textContent = '';
        fromEl.hidden = true;
      }
    }

    // Amount — the only dynamic visual on the card. Prefer the variant's
    // merchant-set title (e.g., "$250") since the actual price may include
    // a surcharge; fall back to formatted amount.
    var amount = s.amount || defaultAmount() || 100;
    var matched = variantForAmount(amount);
    var amtText = (matched && matched.title) ? matched.title : TB.fmtAUD(amount);
    var elAmt = cardEl.querySelector('[data-card-amount]');
    if (elAmt) elAmt.textContent = amtText;

    // Throttled announcement to aria-live (~500ms). Recipient/sender details
    // live in the email payload, not on the card face — only amount + design
    // are surfaced visually so that's all the SR announces.
    var now = Date.now();
    if (now - lastAnnounce > 500) {
      lastAnnounce = now;
      var designLabel = design && design.label ? design.label : 'no design';
      cardEl.setAttribute('data-tb-announce', amtText + ', ' + designLabel);
    }
  };

  // ----- Validation per step -----
  TB.canAdvance = function (n, state) {
    var s = state || TB.getState();
    switch (n) {
      case 1: return true; // Recipient name optional in friend mode; self mode is fine
      case 2: return ALLOWED_EVENTS.indexOf(s.event) !== -1;
      case 3: {
        if (!s.design) return false;
        if (s.design === 'custom') return !!uploadedFile;
        if (s.design === 'designer') return !!generatedDataUrl;
        // Otherwise must match a rendered block id
        for (var d = 0; d < designData.length; d++) {
          if (designData[d].id === s.design) return true;
        }
        return false;
      }
      case 4: {
        if (!s.amount) return false;
        if (!variantForAmount(s.amount)) return false;
        var q = parseInt(s.qty, 10);
        return q >= MIN_QTY && q <= MAX_QTY;
      }
      case 5: return true; // Message optional
      case 6: {
        if (!s.email || !EMAIL_RE.test(s.email)) return false;
        if (s.email !== s.emailConfirm) return false;
        if (s.date) {
          var d = new Date(s.date + 'T00:00:00');
          if (isNaN(d.getTime())) return false;
          var today = new Date(); today.setHours(0,0,0,0);
          var max = new Date(); max.setDate(max.getDate() + DATE_MAX_DAYS);
          if (d < today || d > max) return false;
        }
        return true;
      }
      case 7: {
        // All prior steps must be satisfied
        for (var i = 1; i <= 6; i++) {
          if (!TB.canAdvance(i, s)) return false;
        }
        return true;
      }
    }
    return true;
  };

  // ----- Step swap -----
  // changed: whether step number actually changed since last call (controls focus/scroll)
  TB.showStep = function (n) {
    n = parseInt(n, 10) || 1;
    if (n < 1) n = 1; if (n > STEPS) n = STEPS;
    var stepChanged = n !== currentStep;
    var firstMount = currentStep === 0 || currentStep == null;
    currentStep = n;
    var steps = panel.querySelectorAll('.gcw-step');
    for (var i = 0; i < steps.length; i++) {
      var idx = parseInt(steps[i].getAttribute('data-step'), 10);
      var visible = idx === n;
      steps[i].hidden = !visible;
      if (visible && stepChanged && !firstMount) {
        var h = steps[i].querySelector('h1, [data-focus]');
        if (h && document.body.contains(h)) {
          setTimeout(function (el) { return function () {
            try { el.setAttribute('tabindex', '-1'); el.focus({ preventScroll: true }); } catch(e){}
          }; }(h), 0);
        }
      }
    }
    // Progress
    if (progressEl) {
      var segs = progressEl.querySelectorAll('[data-progress-seg]');
      for (var j = 0; j < segs.length; j++) {
        if (j < n) segs[j].classList.add('is-on'); else segs[j].classList.remove('is-on');
      }
    }
    // Back link
    var back = root.querySelector('[data-gcw-back]');
    if (back) {
      back.textContent = n === 1 ? '← Back to shop' : '← Back';
      back.setAttribute('aria-label', n === 1 ? 'Back to shop' : 'Back to previous step');
    }
    TB.updateCta();
    // Only scroll to top when step actually changes
    if (stepChanged && !firstMount) {
      try { window.scrollTo({ top: 0, behavior: 'auto' }); } catch(e){}
    }
  };

  // ----- CTA copy + state -----
  TB.updateCta = function () {
    if (!ctaEl) return;
    var s = TB.getState();
    var n = currentStep;
    var label = CTA_LABELS[n] || '';
    if (n === 7) {
      var amt = Number(s.amount || 0);
      var qty = parseInt(s.qty, 10) || 1;
      label = 'Confirm & pay — ' + TB.fmtAUD(amt * qty) + ' AUD';
    }
    ctaEl.textContent = inflight ? 'Adding…' : label;
    var ok = TB.canAdvance(n, s) && !inflight;
    ctaEl.disabled = !ok;
    ctaEl.classList.toggle('is-disabled', !ok);
  };

  // ----- Sync DOM controls from URL state on render -----
  TB.syncControls = function () {
    var s = TB.getState();

    // Tabs (friend/self)
    var tabs = root.querySelectorAll('[data-gcw-tab]');
    for (var i = 0; i < tabs.length; i++) {
      var v = tabs[i].getAttribute('data-gcw-tab');
      var active = (v === 'self' && s.self === '1') || (v === 'friend' && s.self !== '1');
      tabs[i].classList.toggle('is-on', active);
      tabs[i].setAttribute('aria-selected', active ? 'true' : 'false');
      tabs[i].setAttribute('tabindex', active ? '0' : '-1');
    }
    var friendBlock = root.querySelector('[data-gcw-friend-fields]');
    var selfBlock = root.querySelector('[data-gcw-self-note]');
    if (friendBlock) friendBlock.hidden = (s.self === '1');
    if (selfBlock) selfBlock.hidden = (s.self !== '1');

    // Inputs
    var inputs = root.querySelectorAll('[data-gcw-input]');
    for (var k = 0; k < inputs.length; k++) {
      var key = inputs[k].getAttribute('data-gcw-input');
      var val = s[key] || '';
      // For email field, prefill with customer email if blank and self mode
      if (key === 'email' && !val && s.self === '1' && initialData.customer_email) {
        val = initialData.customer_email;
      }
      if (inputs[k].value !== val) inputs[k].value = val;
    }

    // Event buttons
    var events = root.querySelectorAll('[data-gcw-event]');
    for (var ev = 0; ev < events.length; ev++) {
      var evVal = events[ev].getAttribute('data-gcw-event');
      var evOn = evVal === s.event;
      events[ev].classList.toggle('is-on', evOn);
      events[ev].setAttribute('aria-checked', evOn ? 'true' : 'false');
      events[ev].setAttribute('tabindex', evOn ? '0' : '-1');
    }
    if (!root.querySelector('[data-gcw-event].is-on') && events[0]) {
      events[0].setAttribute('tabindex', '0');
    }

    // Suggested-message chips (event-tailored). Build via DOM, never innerHTML.
    var sugList = root.querySelector('[data-gcw-suggestions-list]');
    if (sugList) {
      var key = ALLOWED_EVENTS.indexOf(s.event) !== -1 ? s.event : 'other';
      var bank = SUGGESTIONS[key] || SUGGESTIONS['other'];
      var existing = sugList.getAttribute('data-current-event');
      if (existing !== key) {
        sugList.setAttribute('data-current-event', key);
        while (sugList.firstChild) sugList.removeChild(sugList.firstChild);
        for (var sg = 0; sg < bank.length; sg++) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.setAttribute('data-gcw-suggest', bank[sg]);
          btn.textContent = bank[sg];
          sugList.appendChild(btn);
        }
      }
    }

    // Design thumbs (block-driven)
    var thumbs = root.querySelectorAll('[data-gcw-design]');
    for (var t = 0; t < thumbs.length; t++) {
      var dv = thumbs[t].getAttribute('data-gcw-design');
      var on = dv === s.design;
      thumbs[t].classList.toggle('is-on', on);
      thumbs[t].setAttribute('aria-checked', on ? 'true' : 'false');
      thumbs[t].setAttribute('tabindex', on ? '0' : '-1');
      // Mirror to wrapping cell so the label below gets the selected styling.
      var cell = thumbs[t].closest('[data-design-id]');
      if (cell) cell.classList.toggle('is-on', on);
    }
    // Custom-upload tile
    var uploadBtn = root.querySelector('[data-gcw-upload]');
    if (uploadBtn) {
      var customOn = s.design === 'custom';
      uploadBtn.classList.toggle('is-on', customOn);
      uploadBtn.setAttribute('aria-checked', customOn ? 'true' : 'false');
      uploadBtn.setAttribute('tabindex', customOn ? '0' : '-1');
      var uploadCell = uploadBtn.closest('.gcw-thumb-cell');
      if (uploadCell) uploadCell.classList.toggle('is-on', customOn);
    }
    // Designer tile
    var designerBtn = root.querySelector('[data-gcw-designer-open]');
    if (designerBtn) {
      var designerOn = s.design === 'designer';
      designerBtn.classList.toggle('is-on', designerOn);
      designerBtn.setAttribute('aria-checked', designerOn ? 'true' : 'false');
      designerBtn.setAttribute('tabindex', designerOn ? '0' : '-1');
      var designerCell = designerBtn.closest('.gcw-thumb-cell');
      if (designerCell) designerCell.classList.toggle('is-on', designerOn);
      // Reflect generated thumb on the tile if we have a composite
      var designerThumbImg = designerBtn.querySelector('.gcw-thumb__img--designer');
      if (designerThumbImg) {
        if (designerOn && generatedDataUrl) {
          designerThumbImg.src = generatedDataUrl;
          designerThumbImg.hidden = false;
          designerBtn.classList.add('has-design');
        } else {
          designerThumbImg.hidden = true;
          designerBtn.classList.remove('has-design');
        }
      }
    }
    // Ensure at least one is tabbable when no match
    if (!root.querySelector('[data-gcw-design].is-on, [data-gcw-upload].is-on, [data-gcw-designer-open].is-on') && thumbs[0]) {
      thumbs[0].setAttribute('tabindex', '0');
    }

    // Amount chips
    var chips = root.querySelectorAll('[data-gcw-amount]');
    for (var c = 0; c < chips.length; c++) {
      var av = chips[c].getAttribute('data-gcw-amount');
      var aon = String(av) === String(s.amount);
      chips[c].classList.toggle('is-on', aon);
      chips[c].setAttribute('aria-checked', aon ? 'true' : 'false');
      chips[c].setAttribute('tabindex', aon ? '0' : '-1');
    }
    if (!root.querySelector('[data-gcw-amount].is-on') && chips[0]) {
      chips[0].setAttribute('tabindex', '0');
    }

    // Big amount display — prefer the variant's title for the same reason as
    // the card preview (variant titles are the merchant-set marketing values,
    // prices include a surcharge).
    var bigAmt = root.querySelector('[data-gcw-bigamount]');
    if (bigAmt) {
      var bigMatch = s.amount ? variantForAmount(s.amount) : null;
      bigAmt.textContent = (bigMatch && bigMatch.title) ? bigMatch.title : TB.fmtAUD(s.amount || 0);
    }

    // Quantity stepper
    var qtyVal = root.querySelector('[data-gcw-qty-value]');
    if (qtyVal) qtyVal.textContent = s.qty;
    var qDec = root.querySelector('[data-gcw-qty-dec]');
    var qInc = root.querySelector('[data-gcw-qty-inc]');
    var qInt = parseInt(s.qty, 10) || 1;
    if (qDec) qDec.disabled = qInt <= MIN_QTY;
    if (qInc) qInc.disabled = qInt >= MAX_QTY;

    // Counter
    var counter = root.querySelector('[data-gcw-msg-counter]');
    if (counter) counter.textContent = (s.msg ? s.msg.length : 0) + ' / ' + MSG_MAX;

    // Schedule visibility
    var schedToggle = root.querySelector('[data-gcw-schedule-toggle]');
    var schedBlock = root.querySelector('[data-gcw-schedule-block]');
    if (schedBlock) {
      var schedOn = !!s.date || (schedToggle && schedToggle.checked);
      schedBlock.hidden = !schedOn;
      if (schedToggle) schedToggle.checked = schedOn;
    }

    // Email mismatch indicator
    var mm = root.querySelector('[data-gcw-email-mismatch]');
    if (mm) {
      var bad = s.email && s.emailConfirm && s.email !== s.emailConfirm;
      mm.hidden = !bad;
    }

    // Confirm summary
    var summary = root.querySelector('[data-gcw-summary]');
    if (summary) {
      var fillSummary = function (key, val) {
        var node = summary.querySelector('[data-summary="' + key + '"]');
        if (node) node.textContent = val || '—';
      };
      var summaryDesign = designForId(s.design);
      var designLabel = summaryDesign && summaryDesign.label ? summaryDesign.label : '—';
      fillSummary('to', s.self === '1' ? 'For me' : (s.to || 'No name'));
      fillSummary('from', s.from || (s.self === '1' ? '—' : 'No sender'));
      fillSummary('event', EVENT_NAMES[s.event] || '—');
      fillSummary('design', designLabel);
      fillSummary('amount', TB.fmtAUD(s.amount || 0) + ' AUD × ' + s.qty);
      fillSummary('msg', s.msg || 'No message');
      fillSummary('email', s.email || '—');
      fillSummary('date', s.date || 'Send now');
      var totalEl = summary.querySelector('[data-summary="total"]');
      if (totalEl) {
        var amtN = Number(s.amount || 0); var qtyN = parseInt(s.qty,10)||1;
        totalEl.textContent = TB.fmtAUD(amtN * qtyN) + ' AUD';
      }
    }

    // Update "Change" links
    var changeLinks = root.querySelectorAll('[data-gcw-change]');
    for (var cl = 0; cl < changeLinks.length; cl++) {
      var stepN = changeLinks[cl].getAttribute('data-gcw-change');
      changeLinks[cl].setAttribute('href', TB.buildUrl({ step: stepN }));
    }
  };

  // ----- Master render: sync controls + card + cta -----
  TB.render = function () {
    var s = TB.getState();
    TB.syncControls();
    TB.renderCard(s);
    TB.showStep(parseInt(s.step, 10) || 1);
  };

  // =========================================================
  // Composer ("Design it yourself")
  // =========================================================

  function persistComposer() {
    try {
      var snap = {
        type: composer.type,
        backgroundId: composer.backgroundId,
        bgCategory: composer.bgCategory || 'all',
        emojis: composer.emojis.map(function (e) { return { id: e.id, char: e.char, x: e.x, y: e.y, scale: e.scale || 1, rotate: e.rotate || 0 }; }),
        products: composer.products.map(function (p) { return { handle: p.handle, image: p.image, title: p.title, x: p.x, y: p.y, scale: p.scale, rotate: p.rotate || 0, mask: p.mask || 'square', removeWhite: p.removeWhite !== false }; }),
        drawingDataUrl: composer.drawingDataUrl || ''
      };
      sessionStorage.setItem(COMPOSER_STORAGE_KEY, JSON.stringify(snap));
    } catch (e) { /* sessionStorage may be unavailable */ }
  }
  function restoreComposer() {
    try {
      var raw = sessionStorage.getItem(COMPOSER_STORAGE_KEY);
      if (!raw) return;
      var snap = JSON.parse(raw);
      if (!snap || typeof snap !== 'object') return;
      composer.type = snap.type || '';
      composer.backgroundId = snap.backgroundId || '';
      composer.bgCategory = (BG_CATEGORIES.indexOf(snap.bgCategory) !== -1) ? snap.bgCategory : 'all';
      // Defensive: only restore emojis with a `char` (legacy snapshots used
      // `sprites` with image URLs — those are silently discarded).
      composer.emojis = Array.isArray(snap.emojis) ? snap.emojis.filter(function (e) {
        return e && typeof e.char === 'string' && e.char.length > 0;
      }).map(function (e) {
        return {
          id: e.id || ('e' + Date.now() + '_' + Math.random().toString(36).slice(2, 6)),
          char: e.char,
          x: typeof e.x === 'number' ? e.x : 0.5,
          y: typeof e.y === 'number' ? e.y : 0.5,
          scale: e.scale || 1,
          rotate: e.rotate || 0
        };
      }) : [];
      composer.drawingDataUrl = (typeof snap.drawingDataUrl === 'string') ? snap.drawingDataUrl : '';
      composer.products = Array.isArray(snap.products) ? snap.products.map(function (p) {
        return {
          handle: p.handle, image: p.image, title: p.title,
          x: p.x, y: p.y, scale: p.scale || 1,
          rotate: typeof p.rotate === 'number' ? p.rotate : 0,
          mask: p.mask || 'square',
          removeWhite: p.removeWhite !== false,
          processedDataUrl: null
        };
      }) : [];
    } catch (e) { /* ignore corrupt blobs */ }
  }

  function bgMatchesCategory(tags, cat) {
    cat = cat || 'all';
    if (cat === 'all') return true;
    if (cat === 'soft') {
      return tags.indexOf('soft') !== -1 || tags.indexOf('apology') !== -1 || tags.indexOf('watercolor') !== -1 || tags.indexOf('topographic') !== -1;
    }
    return tags.indexOf(cat) !== -1;
  }

  function applyTypeFilter(type) {
    var t = (type || '').toLowerCase().trim();
    var cat = composer.bgCategory || 'all';
    var bgs = root.querySelectorAll('[data-gcw-bg-id]');
    var firstVisible = null;
    for (var i = 0; i < bgs.length; i++) {
      var tags = (bgs[i].getAttribute('data-gcw-bg-tags') || '').toLowerCase();
      var occasionOk = !t || t === 'other' || tags.indexOf(t) !== -1;
      var categoryOk = bgMatchesCategory(tags, cat);
      var show = occasionOk && categoryOk;
      bgs[i].hidden = !show;
      if (show && !firstVisible) firstVisible = bgs[i];
    }
    var empty = root.querySelector('[data-gcw-bg-empty]');
    if (empty) empty.hidden = !!firstVisible;
  }

  function syncComposerControls() {
    // Type buttons
    var tbtns = root.querySelectorAll('[data-gcw-composer-type]');
    var activeType = composer.type || 'other';
    for (var i = 0; i < tbtns.length; i++) {
      var v = tbtns[i].getAttribute('data-gcw-composer-type');
      var on = v === activeType;
      tbtns[i].setAttribute('aria-checked', on ? 'true' : 'false');
    }
    // Background
    var bgs = root.querySelectorAll('[data-gcw-bg-id]');
    for (var k = 0; k < bgs.length; k++) {
      var bid = bgs[k].getAttribute('data-gcw-bg-id');
      bgs[k].setAttribute('aria-checked', bid === composer.backgroundId ? 'true' : 'false');
    }
    var cats = root.querySelectorAll('[data-gcw-bg-cat]');
    var activeCat = composer.bgCategory || 'all';
    for (var c = 0; c < cats.length; c++) {
      cats[c].setAttribute('aria-checked', cats[c].getAttribute('data-gcw-bg-cat') === activeCat ? 'true' : 'false');
    }
    applyTypeFilter(activeType);
  }

  function addDesignerBgTile(rec, prepend) {
    if (!rec || !rec.id || !rec.image) return;
    for (var i = 0; i < designerBgData.length; i++) {
      if (designerBgData[i].id === rec.id) {
        designerBgData[i] = rec;
        break;
      }
    }
    if (i === designerBgData.length) designerBgData.push(rec);
    var bgGrid = root.querySelector('[data-gcw-bg-grid]');
    if (!bgGrid || root.querySelector('[data-gcw-bg-id="' + rec.id + '"]')) return;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'gcw-composer__bg';
    btn.setAttribute('data-gcw-bg-id', rec.id);
    btn.setAttribute('data-gcw-bg-tags', rec.tags || 'all');
    btn.setAttribute('aria-label', rec.label || 'Background');
    btn.setAttribute('aria-checked', 'false');
    var img = document.createElement('img');
    img.src = rec.image;
    img.alt = '';
    img.loading = 'lazy';
    img.decoding = 'async';
    btn.appendChild(img);
    if (prepend && bgGrid.firstChild) bgGrid.insertBefore(btn, bgGrid.firstChild);
    else bgGrid.appendChild(btn);
  }


  function setCardBg(url) {
    if (!cardEl) return;
    var bgEl = cardEl.querySelector('[data-gcw-card-bg]');
    if (!bgEl) return;
    if (url) {
      if (bgEl.getAttribute('src') !== url) bgEl.setAttribute('src', url);
      bgEl.hidden = false;
    }
  }

  // Chroma-key near-white pixels to transparent. Returns a PNG dataURL.
  // Image must already be CORS-clean (loaded with crossOrigin='anonymous').
  function chromaKeyWhite(image) {
    return new Promise(function (resolve) {
      try {
        var c = document.createElement('canvas');
        c.width = image.naturalWidth || image.width;
        c.height = image.naturalHeight || image.height;
        var ctx = c.getContext('2d');
        ctx.drawImage(image, 0, 0);
        var data = ctx.getImageData(0, 0, c.width, c.height);
        var d = data.data;
        var THRESHOLD = 240;
        for (var i = 0; i < d.length; i += 4) {
          if (d[i] >= THRESHOLD && d[i+1] >= THRESHOLD && d[i+2] >= THRESHOLD) {
            d[i+3] = 0;
          } else {
            var maxRGB = Math.max(d[i], d[i+1], d[i+2]);
            if (maxRGB >= 220) {
              d[i+3] = Math.round(d[i+3] * (1 - (maxRGB - 220) / 35));
            }
          }
        }
        ctx.putImageData(data, 0, 0);
        resolve(c.toDataURL('image/png'));
      } catch (err) {
        resolve(null); // CORS / taint failure — caller falls back to original
      }
    });
  }

  // Process a product layer's image asynchronously. Stores processedDataUrl on
  // the layer record and re-applies to the live <img> on success.
  function processProductLayer(item) {
    if (!item || item.removeWhite === false) return;
    if (item.processedDataUrl) {
      if (item._el) {
        var liveImg = item._el.querySelector('img');
        if (liveImg && liveImg.src !== item.processedDataUrl) liveImg.src = item.processedDataUrl;
      }
      return;
    }
    var probe = new Image();
    probe.crossOrigin = 'anonymous';
    probe.onload = function () {
      chromaKeyWhite(probe).then(function (dataUrl) {
        if (!dataUrl) return; // fall back: keep original src
        item.processedDataUrl = dataUrl;
        if (item._el) {
          var liveImg = item._el.querySelector('img');
          if (liveImg) liveImg.src = dataUrl;
        }
      });
    };
    probe.onerror = function () { /* CORS or load fail — leave original src */ };
    probe.src = item.image;
  }

  function makeLayerDraggable(el, onMove) {
    var dragging = false, startX, startY, originX, originY, rect;
    el.addEventListener('pointerdown', function (e) {
      // Ignore drags that originate on the delete / rotate / resize / options controls
      if (e.target && e.target.closest && e.target.closest('.gcw-card-layer__del, .gcw-card-layer__rotate, .gcw-card-layer__resize, .gcw-card-layer__options')) return;
      // Suppress position-drag while a pinch gesture is active (2+ touches).
      if (el.__gcwPinchActive) return;
      e.preventDefault();
      try { el.setPointerCapture(e.pointerId); } catch (err) {}
      dragging = true;
      startX = e.clientX; startY = e.clientY;
      var parent = el.parentElement;
      rect = parent.getBoundingClientRect();
      var cs = window.getComputedStyle(el);
      originX = parseFloat(cs.left) || 0;
      originY = parseFloat(cs.top) || 0;
    });
    el.addEventListener('pointermove', function (e) {
      if (!dragging || !rect) return;
      if (el.__gcwPinchActive) { dragging = false; return; }
      var dx = e.clientX - startX;
      var dy = e.clientY - startY;
      var nx = (originX + dx) / rect.width;
      var ny = (originY + dy) / rect.height;
      nx = Math.max(0, Math.min(1, nx));
      ny = Math.max(0, Math.min(1, ny));
      el.style.left = (nx * rect.width) + 'px';
      el.style.top = (ny * rect.height) + 'px';
      onMove(nx, ny);
    });
    function endDrag(e) {
      dragging = false;
      try { el.releasePointerCapture(e.pointerId); } catch (err) {}
    }
    el.addEventListener('pointerup', endDrag);
    el.addEventListener('pointercancel', endDrag);
  }

  function applyLayerTransform(el, item) {
    var r = (typeof item.rotate === 'number') ? item.rotate : 0;
    el.style.transform = 'translate(-50%, -50%) rotate(' + r + 'deg)';
  }
  function applyLayerMask(item) {
    if (!item._el) return;
    var img = item._el.querySelector('img');
    if (!img) return;
    var maskKey = item.mask || 'square';
    var clip = SHAPE_MASKS[maskKey] || 'none';
    img.style.clipPath = clip;
    img.style.webkitClipPath = clip;
  }

  function makeRotatable(layer, handle, onRotate) {
    var dragging = false;
    handle.addEventListener('pointerdown', function (e) {
      e.preventDefault();
      e.stopPropagation();
      try { handle.setPointerCapture(e.pointerId); } catch (err) {}
      dragging = true;
    });
    handle.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var rect = layer.getBoundingClientRect();
      var cx = rect.left + rect.width / 2;
      var cy = rect.top + rect.height / 2;
      var angle = Math.atan2(e.clientY - cy, e.clientX - cx) * 180 / Math.PI + 90;
      var norm = ((angle % 360) + 360) % 360;
      onRotate(norm);
    });
    function endRot(e) {
      dragging = false;
      try { handle.releasePointerCapture(e.pointerId); } catch (err) {}
    }
    handle.addEventListener('pointerup', endRot);
    handle.addEventListener('pointercancel', endRot);
  }

  function clampScale(s) {
    if (!isFinite(s)) return 1;
    return Math.max(SCALE_MIN, Math.min(SCALE_MAX, s));
  }
  function applyScale(layer, item, scale) {
    var s = clampScale(scale);
    var img = layer.querySelector('img');
    var span = layer.querySelector('span');
    if (img) img.style.width = (BASE_PX * s) + 'px';
    if (span) span.style.fontSize = (BASE_FONT_PX * s) + 'px';
  }
  function makeResizable(layer, handle, item, onChange, onCommit) {
    var dragging = false;
    var startScale = 1;
    var startDist = 0;
    function distFromCenter(e) {
      var r = layer.getBoundingClientRect();
      var cx = r.left + r.width / 2;
      var cy = r.top + r.height / 2;
      var dx = e.clientX - cx;
      var dy = e.clientY - cy;
      return Math.sqrt(dx * dx + dy * dy);
    }
    handle.addEventListener('pointerdown', function (e) {
      e.preventDefault();
      e.stopPropagation();
      try { handle.setPointerCapture(e.pointerId); } catch (err) {}
      dragging = true;
      startScale = item.scale || 1;
      startDist = distFromCenter(e);
      if (startDist < 4) startDist = 4;
    });
    handle.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var d = distFromCenter(e);
      var s = clampScale(startScale * (d / startDist));
      item.scale = s;
      onChange(s);
    });
    function endResize(e) {
      if (!dragging) return;
      dragging = false;
      try { handle.releasePointerCapture(e.pointerId); } catch (err) {}
      if (typeof onCommit === 'function') onCommit();
    }
    handle.addEventListener('pointerup', endResize);
    handle.addEventListener('pointercancel', endResize);
  }

  function selectLayer(item) {
    if (composer.selectedLayer === item) return;
    composer.selectedLayer = item;
    var layerHost = root.querySelector('[data-gcw-card-layers]');
    if (!layerHost) return;
    var all = layerHost.querySelectorAll('.gcw-card-layer');
    for (var i = 0; i < all.length; i++) all[i].classList.remove('is-selected');
    if (item && item._el) item._el.classList.add('is-selected');
  }
  function clearLayerSelection() {
    if (!composer.selectedLayer) return;
    var prev = composer.selectedLayer;
    composer.selectedLayer = null;
    if (prev && prev._el) prev._el.classList.remove('is-selected');
  }

  function buildOptionsPopover(item, kind) {
    var pop = document.createElement('div');
    pop.className = 'gcw-card-layer__options';
    // Stop pointer events bubbling so clicks here don't move the layer.
    pop.addEventListener('pointerdown', function (e) { e.stopPropagation(); });
    pop.addEventListener('click', function (e) { e.stopPropagation(); });

    // Shape buttons
    var shapes = [
      { key: 'square',  label: 'Square',  glyph: '□' },
      { key: 'circle',  label: 'Circle',  glyph: '◯' },
      { key: 'rounded', label: 'Rounded', glyph: '▢' },
      { key: 'hexagon', label: 'Hexagon', glyph: '⬢' },
      { key: 'star',    label: 'Star',    glyph: '★' }
    ];
    var shapeRow = document.createElement('div');
    shapeRow.className = 'gcw-card-layer__opt-row';
    shapes.forEach(function (s) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'gcw-card-layer__shape';
      b.setAttribute('data-shape', s.key);
      b.setAttribute('aria-label', s.label);
      b.setAttribute('aria-pressed', (item.mask || 'square') === s.key ? 'true' : 'false');
      b.textContent = s.glyph;
      b.addEventListener('click', function (e) {
        e.preventDefault();
        item.mask = s.key;
        applyLayerMask(item);
        var sibs = pop.querySelectorAll('.gcw-card-layer__shape');
        for (var i = 0; i < sibs.length; i++) {
          sibs[i].setAttribute('aria-pressed', sibs[i].getAttribute('data-shape') === s.key ? 'true' : 'false');
        }
        persistComposer();
      });
      shapeRow.appendChild(b);
    });
    pop.appendChild(shapeRow);

    // White-removal chip — products only
    if (kind === 'product') {
      var chip = document.createElement('button');
      chip.type = 'button';
      chip.className = 'gcw-card-layer__chip';
      chip.setAttribute('aria-pressed', item.removeWhite !== false ? 'true' : 'false');
      function refreshChipLabel() {
        chip.textContent = (item.removeWhite !== false ? '✓ ' : '') + 'Remove white';
      }
      refreshChipLabel();
      chip.addEventListener('click', function (e) {
        e.preventDefault();
        item.removeWhite = !(item.removeWhite !== false);
        chip.setAttribute('aria-pressed', item.removeWhite ? 'true' : 'false');
        refreshChipLabel();
        var liveImg = item._el ? item._el.querySelector('img') : null;
        if (item.removeWhite) {
          if (item.processedDataUrl && liveImg) {
            liveImg.src = item.processedDataUrl;
          } else {
            processProductLayer(item);
          }
        } else if (liveImg) {
          liveImg.src = item.image;
        }
        persistComposer();
      });
      pop.appendChild(chip);
    }

    return pop;
  }

  function placeLayerEl(layerHost, item, kind) {
    var el = document.createElement('div');
    el.className = 'gcw-card-layer gcw-card-layer--' + kind;
    el.setAttribute('data-layer-kind', kind);
    el.setAttribute('data-layer-ref', kind === 'emoji' ? item.id : item.handle);

    if (kind === 'emoji') {
      // Emojis render as text — no <img>, no shape mask popover.
      var span = document.createElement('span');
      span.textContent = item.char;
      el.appendChild(span);
    } else {
      var img = document.createElement('img');
      img.crossOrigin = 'anonymous';
      img.alt = '';
      img.draggable = false;
      img.src = item.image;
      el.appendChild(img);
    }

    var del = document.createElement('button');
    del.type = 'button';
    del.className = 'gcw-card-layer__del';
    del.setAttribute('aria-label', 'Remove');
    del.textContent = '✕'; // multiplication X (NOT an emoji variant)
    el.appendChild(del);

    var rotate = document.createElement('button');
    rotate.type = 'button';
    rotate.className = 'gcw-card-layer__rotate';
    rotate.setAttribute('aria-label', 'Rotate');
    rotate.textContent = '↻';
    el.appendChild(rotate);

    var resize = document.createElement('button');
    resize.type = 'button';
    resize.className = 'gcw-card-layer__resize';
    resize.setAttribute('aria-label', 'Resize');
    resize.setAttribute('tabindex', '-1');
    resize.innerHTML = '<svg viewBox="0 0 12 12" width="12" height="12" aria-hidden="true"><path d="M2 12h10V2" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';
    el.appendChild(resize);

    // Shape-mask popover only makes sense for image content (products).
    if (kind === 'product') {
      var pop = buildOptionsPopover(item, kind);
      el.appendChild(pop);
    }

    // Position + transform
    var rect = layerHost.getBoundingClientRect();
    el.style.left = (item.x * rect.width) + 'px';
    el.style.top = (item.y * rect.height) + 'px';
    if (typeof item.rotate !== 'number') item.rotate = 0;
    applyLayerTransform(el, item);

    layerHost.appendChild(el);
    item._el = el;

    if (kind === 'product') {
      applyLayerMask(item);
      // For products: kick off chroma-key processing (default ON).
      if (item.removeWhite !== false) {
        processProductLayer(item);
      }
    }

    makeLayerDraggable(el, function (nx, ny) {
      item.x = nx;
      item.y = ny;
      persistComposer();
    });

    makeRotatable(el, rotate, function (deg) {
      item.rotate = deg;
      applyLayerTransform(el, item);
      persistComposer();
    });

    // Initial scale applied to the visual element.
    if (typeof item.scale !== 'number' || !isFinite(item.scale)) item.scale = 1;
    applyScale(el, item, item.scale);

    // Drag handle resize (bottom-right corner)
    makeResizable(el, resize, item, function (s) {
      applyScale(el, item, s);
    }, function () {
      persistComposer();
    });

    // Mouse-wheel resize when this layer is selected.
    el.addEventListener('wheel', function (e) {
      if (!el.classList.contains('is-selected')) return;
      e.preventDefault();
      var dir = e.deltaY < 0 ? 1 : -1;
      var s = clampScale((item.scale || 1) * (1 + dir * 0.05));
      item.scale = s;
      applyScale(el, item, s);
      persistComposer();
    }, { passive: false });

    // Two-finger pinch resize. Tracks active touch pointers on this layer.
    var activeTouches = new Map();
    var pinchStartDist = 0;
    var pinchStartScale = 1;
    el.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'touch') return;
      if (!el.classList.contains('is-selected')) return;
      activeTouches.set(e.pointerId, { x: e.clientX, y: e.clientY });
      if (activeTouches.size >= 2) {
        el.__gcwPinchActive = true;
        var pts = Array.from(activeTouches.values());
        pinchStartDist = Math.hypot(pts[0].x - pts[1].x, pts[0].y - pts[1].y) || 1;
        pinchStartScale = item.scale || 1;
      }
    });
    el.addEventListener('pointermove', function (e) {
      if (!activeTouches.has(e.pointerId)) return;
      activeTouches.set(e.pointerId, { x: e.clientX, y: e.clientY });
      if (activeTouches.size >= 2 && pinchStartDist > 0) {
        var pts = Array.from(activeTouches.values());
        var d = Math.hypot(pts[0].x - pts[1].x, pts[0].y - pts[1].y);
        var s = clampScale(pinchStartScale * (d / pinchStartDist));
        item.scale = s;
        applyScale(el, item, s);
        e.preventDefault();
      }
    });
    function endTouch(e) {
      if (activeTouches.has(e.pointerId)) {
        activeTouches.delete(e.pointerId);
        if (activeTouches.size < 2) {
          if (el.__gcwPinchActive) {
            el.__gcwPinchActive = false;
            persistComposer();
          }
          pinchStartDist = 0;
        }
      }
    }
    el.addEventListener('pointerup', endTouch);
    el.addEventListener('pointercancel', endTouch);

    el.addEventListener('pointerdown', function (e) {
      // Selection on press; ignore presses on internal controls so they
      // can run their own handlers without stealing focus.
      if (e.target && e.target.closest && e.target.closest('.gcw-card-layer__del')) return;
      selectLayer(item);
    });

    del.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      removeLayer(kind, item);
    });
  }

  function removeLayer(kind, item) {
    if (composer.selectedLayer === item) composer.selectedLayer = null;
    if (item._el && item._el.parentNode) item._el.parentNode.removeChild(item._el);
    var arr = (kind === 'emoji') ? composer.emojis : composer.products;
    var idx = arr.indexOf(item);
    if (idx !== -1) arr.splice(idx, 1);
    persistComposer();
    refreshProductAddButtons();
  }

  function rebuildLayerHost() {
    var layerHost = root.querySelector('[data-gcw-card-layers]');
    if (!layerHost) return;
    while (layerHost.firstChild) layerHost.removeChild(layerHost.firstChild);
    layerHost.classList.toggle('is-active', !!composer.open);
    // Bind once: clicking on the empty card background deselects all layers.
    if (!layerHost.__gcwDeselectBound) {
      layerHost.__gcwDeselectBound = true;
      layerHost.addEventListener('pointerdown', function (e) {
        if (e.target === layerHost) clearLayerSelection();
      });
    }
    if (!composer.open) return;
    // Render order: emojis first (decoration), products on top (real photos).
    composer.emojis.forEach(function (e) { placeLayerEl(layerHost, e, 'emoji'); });
    composer.products.forEach(function (p) { placeLayerEl(layerHost, p, 'product'); });
  }

  function openComposer() {
    composer.open = true;
    var panelEl = root.querySelector('[data-gcw-composer]');
    var grid = root.querySelector('.gcw__designs');
    if (panelEl) panelEl.hidden = false;
    if (grid) grid.classList.add('is-hidden-by-composer');
    history.replaceState({}, '', TB.buildUrl({ design: 'designer' }));
    // Default type to current event if present, else 'other'
    if (!composer.type) {
      var st = TB.getState();
      composer.type = ALLOWED_EVENTS.indexOf(st.event) !== -1 ? st.event : 'other';
    }
    syncComposerControls();
    rebuildLayerHost();
    // Restore background preview if a bg was previously chosen
    if (composer.backgroundId) {
      var bg = designerBgForId(composer.backgroundId);
      if (bg && bg.image) setCardBg(bg.image);
    }
    // Drawing layer: init canvas, restore prior strokes, surface the toggle.
    initDrawCanvas();
    restoreDrawing();
    showDrawToggle();
    TB.render();
  }

  function closeComposer() {
    composer.open = false;
    var panelEl = root.querySelector('[data-gcw-composer]');
    var grid = root.querySelector('.gcw__designs');
    if (panelEl) panelEl.hidden = true;
    if (grid) grid.classList.remove('is-hidden-by-composer');
    var layerHost = root.querySelector('[data-gcw-card-layers]');
    if (layerHost) {
      while (layerHost.firstChild) layerHost.removeChild(layerHost.firstChild);
      layerHost.classList.remove('is-active');
    }
    hideDrawUI();
    // If no composite committed yet, clear the 'designer' design state
    if (!generatedDataUrl) {
      history.replaceState({}, '', TB.buildUrl({ design: '' }));
    }
    TB.render();
  }

  function addEmoji(char) {
    if (!char) return;
    var item = {
      id: 'e' + Date.now() + '_' + Math.random().toString(36).slice(2, 6),
      char: char,
      x: 0.5, y: 0.5, scale: 1, rotate: 0
    };
    composer.emojis.push(item);
    var layerHost = root.querySelector('[data-gcw-card-layers]');
    if (layerHost) placeLayerEl(layerHost, item, 'emoji');
    persistComposer();
  }

  // Build category tabs once. Click handlers update composer.emojiCategory and
  // re-render the grid.
  function renderEmojiCategories() {
    var host = root.querySelector('[data-gcw-emoji-cats]');
    if (!host) return;
    while (host.firstChild) host.removeChild(host.firstChild);
    EMOJI_CATEGORIES.forEach(function (cat) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.setAttribute('data-gcw-emoji-cat', cat.id);
      btn.setAttribute('aria-pressed', composer.emojiCategory === cat.id ? 'true' : 'false');
      btn.textContent = cat.label;
      host.appendChild(btn);
    });
  }

  // Render the emoji grid based on current category + search term.
  // Search term takes priority — when present, filter across ALL categories.
  function renderEmojiGrid() {
    var host = root.querySelector('[data-gcw-emoji-grid]');
    if (!host) return;
    var q = (composer.emojiSearch || '').trim().toLowerCase();
    var cat = composer.emojiCategory || 'hot';
    var filtered;
    if (q) {
      // Search overrides category — match across the full bank.
      filtered = EMOJI_BANK.filter(function (e) { return e.name.indexOf(q) !== -1; });
    } else if (cat === 'hot') {
      // Hot: render only the curated chars, in declared order. Look up each
      // char in EMOJI_BANK so the title/aria text matches the live keywords.
      filtered = EMOJI_HOT.map(function (ch) {
        for (var i = 0; i < EMOJI_BANK.length; i++) {
          if (EMOJI_BANK[i].char === ch) return EMOJI_BANK[i];
        }
        return { char: ch, name: ch, category: 'hot' };
      });
    } else if (cat === 'all') {
      filtered = EMOJI_BANK.slice();
    } else {
      filtered = EMOJI_BANK.filter(function (e) { return e.category === cat; });
    }
    while (host.firstChild) host.removeChild(host.firstChild);
    if (!filtered.length) {
      var empty = document.createElement('div');
      empty.className = 'gcw-composer__emoji-empty';
      empty.textContent = 'No emojis found';
      host.appendChild(empty);
      return;
    }
    filtered.forEach(function (e) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.setAttribute('data-gcw-emoji-pick', e.char);
      btn.setAttribute('aria-label', e.name);
      btn.setAttribute('title', e.name);
      btn.textContent = e.char;
      host.appendChild(btn);
    });
  }

  function syncEmojiCategoryButtons() {
    var btns = root.querySelectorAll('[data-gcw-emoji-cat]');
    for (var i = 0; i < btns.length; i++) {
      var v = btns[i].getAttribute('data-gcw-emoji-cat');
      btns[i].setAttribute('aria-pressed', v === composer.emojiCategory ? 'true' : 'false');
    }
  }

  function addProduct(prod) {
    if (composer.products.length >= 4) {
      var err = root.querySelector('[data-gcw-product-error]');
      if (err) { err.textContent = 'Up to 4 products.'; err.hidden = false; }
      return;
    }
    var item = {
      handle: prod.handle,
      image: prod.image,
      title: prod.title,
      x: 0.5, y: 0.5, scale: 1,
      rotate: 0,
      mask: 'square',
      removeWhite: true,
      processedDataUrl: null
    };
    composer.products.push(item);
    var layerHost = root.querySelector('[data-gcw-card-layers]');
    if (layerHost) placeLayerEl(layerHost, item, 'product');
    persistComposer();
    refreshProductAddButtons();
  }

  function refreshProductAddButtons() {
    var btns = root.querySelectorAll('[data-gcw-product-add]');
    var atMax = composer.products.length >= 4;
    for (var i = 0; i < btns.length; i++) btns[i].disabled = atMax;
    var err = root.querySelector('[data-gcw-product-error]');
    if (err && !atMax) { err.textContent = ''; err.hidden = true; }
  }

  function searchProducts(query) {
    if (!query || query.length < 2) return Promise.resolve([]);
    var token = (initialData && initialData.storefront_token) || 'cd297553df7bc05064d96b95956428e9';
    var version = (initialData && initialData.storefront_api_version) || '2025-01';
    var url = '/api/' + version + '/graphql.json';
    var gql = 'query Search($q: String!) {' +
      '  products(first: 12, query: $q) {' +
      '    edges { node {' +
      '      handle' +
      '      title' +
      '      images(first: 10) { edges { node { url(transform: { maxWidth: 600 }) altText } } }' +
      '    } }' +
      '  }' +
      '}';
    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': token,
        'Accept': 'application/json'
      },
      body: JSON.stringify({ query: gql, variables: { q: query } })
    }).then(function (r) { return r.json(); }).then(function (data) {
      if (!data || !data.data || !data.data.products) return [];
      return data.data.products.edges.map(function (e) {
        var node = e.node;
        var imgs = (node && node.images && node.images.edges) ? node.images.edges
          .map(function (ie) { return ie.node && ie.node.url; })
          .filter(Boolean) : [];
        return { handle: node.handle, title: node.title, images: imgs };
      }).filter(function (n) { return n.images.length > 0; });
    }).catch(function () { return []; });
  }

  function renderProductResults(nodes) {
    var host = root.querySelector('[data-gcw-product-results]');
    if (!host) return;
    while (host.firstChild) host.removeChild(host.firstChild);
    if (!nodes.length) {
      var empty = document.createElement('div');
      empty.className = 'gcw-composer__product-empty';
      empty.textContent = 'No products found. Try another category or keyword.';
      host.appendChild(empty);
      return;
    }
    nodes.forEach(function (n) {
      var article = document.createElement('article');
      article.className = 'gcw-composer__product-result';
      article.setAttribute('data-handle', n.handle);
      article.setAttribute('data-title', n.title);
      article.setAttribute('data-images', JSON.stringify(n.images));
      article.setAttribute('data-current-index', '0');

      var multi = n.images.length > 1;

      var media = document.createElement('div');
      media.className = 'gcw-result__media';

      var prev = document.createElement('button');
      prev.type = 'button';
      prev.className = 'gcw-result__nav gcw-result__nav--prev';
      prev.setAttribute('aria-label', 'Previous image');
      prev.setAttribute('data-gcw-result-prev', '');
      prev.textContent = '‹';
      if (!multi) prev.hidden = true;

      var img = document.createElement('img');
      img.className = 'gcw-result__img';
      img.src = n.images[0];
      img.alt = '';
      img.loading = 'lazy';

      var next = document.createElement('button');
      next.type = 'button';
      next.className = 'gcw-result__nav gcw-result__nav--next';
      next.setAttribute('aria-label', 'Next image');
      next.setAttribute('data-gcw-result-next', '');
      next.textContent = '›';
      if (!multi) next.hidden = true;

      media.appendChild(prev);
      media.appendChild(img);
      media.appendChild(next);

      var meta = document.createElement('div');
      meta.className = 'gcw-result__meta';
      var titleEl = document.createElement('span');
      titleEl.className = 'gcw-result__title';
      titleEl.textContent = n.title;
      var counter = document.createElement('span');
      counter.className = 'gcw-result__counter';
      counter.setAttribute('data-gcw-result-counter', '');
      counter.textContent = '1 / ' + n.images.length;
      if (!multi) counter.hidden = true;
      meta.appendChild(titleEl);
      meta.appendChild(counter);

      var addBtn = document.createElement('button');
      addBtn.type = 'button';
      addBtn.className = 'gcw-result__add';
      addBtn.setAttribute('data-gcw-product-add', '');
      addBtn.textContent = 'Add this image';

      article.appendChild(media);
      article.appendChild(meta);
      article.appendChild(addBtn);
      host.appendChild(article);
    });
    refreshProductAddButtons();
  }

  // Cycle a single product result's carousel by delta (+1/-1).
  function cycleResultImage(article, delta) {
    var imgs;
    try { imgs = JSON.parse(article.getAttribute('data-images') || '[]'); } catch (e) { imgs = []; }
    if (!imgs.length) return;
    var idx = parseInt(article.getAttribute('data-current-index') || '0', 10) || 0;
    idx = (idx + delta + imgs.length) % imgs.length;
    article.setAttribute('data-current-index', String(idx));
    var img = article.querySelector('.gcw-result__img');
    if (img) img.src = imgs[idx];
    var counter = article.querySelector('[data-gcw-result-counter]');
    if (counter) counter.textContent = (idx + 1) + ' / ' + imgs.length;
  }

  // Load image with CORS for canvas safety
  function loadImage(src) {
    return new Promise(function (resolve, reject) {
      if (!src) return reject(new Error('no src'));
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function () { resolve(img); };
      img.onerror = function () { reject(new Error('image load failed: ' + src)); };
      img.src = src;
    });
  }

  function drawImageCover(ctx, img, x, y, w, h) {
    var iw = img.naturalWidth || img.width || w;
    var ih = img.naturalHeight || img.height || h;
    var scale = Math.max(w / iw, h / ih);
    var sw = w / scale;
    var sh = h / scale;
    var sx = (iw - sw) / 2;
    var sy = (ih - sh) / 2;
    ctx.drawImage(img, sx, sy, sw, sh, x, y, w, h);
  }

  // Compose layered card to a single PNG via Canvas.
  // Note: we deliberately omit the brand logo from buyer-composed designs —
  // the buyer is expressing their own art, full-bleed, so the logo would
  // fight with their composition. The merchant's preset backgrounds can
  // bake-in brand marks if desired.
  function composeToBlob() {
    var canvas = document.createElement('canvas');
    canvas.width = CARD_RENDER_W;
    canvas.height = CARD_RENDER_H;
    var ctx = canvas.getContext('2d');

    var bg = designerBgForId(composer.backgroundId);
    var bgPromise = (bg && bg.image)
      ? loadImage(bg.image).then(function (img) {
          drawImageCover(ctx, img, 0, 0, CARD_RENDER_W, CARD_RENDER_H);
        }).catch(function () {
          ctx.fillStyle = '#0a0a0a';
          ctx.fillRect(0, 0, CARD_RENDER_W, CARD_RENDER_H);
        })
      : (function () { ctx.fillStyle = '#0a0a0a'; ctx.fillRect(0, 0, CARD_RENDER_W, CARD_RENDER_H); return Promise.resolve(); })();

    // DOM reference width: the live card preview's pixel width. Used to
    // convert per-layer DOM pixel sizes (BASE_PX, BASE_FONT_PX) into the
    // canvas's coordinate space. Falls back to 520 (typical preview width)
    // if the card element isn't available for some reason.
    var DOM_REFERENCE_W = 520;
    if (cardEl) {
      var cardRect = cardEl.getBoundingClientRect();
      if (cardRect && cardRect.width > 0) DOM_REFERENCE_W = cardRect.width;
    }
    var domToCanvas = CARD_RENDER_W / DOM_REFERENCE_W;

    return bgPromise.then(function () {
      // Emojis first (decoration), then products on top (real photos).
      // Emojis render via fillText; products via drawImage with optional masks.
      composer.emojis.forEach(function (em) {
        var cx = em.x * CARD_RENDER_W;
        var cy = em.y * CARD_RENDER_H;
        var rot = (typeof em.rotate === 'number') ? em.rotate : 0;
        var scl = (typeof em.scale === 'number' && em.scale > 0) ? em.scale : 1;
        ctx.save();
        ctx.translate(cx, cy);
        if (rot) ctx.rotate(rot * Math.PI / 180);
        // CSS font-size at scale 1 is BASE_FONT_PX (64px) on the live preview.
        // Translate to canvas coordinates, then ×2.5 to compensate for the gap
        // between Canvas font-size pixel rendering and CSS font-size rendering
        // for emoji glyphs.
        var fontPx = BASE_FONT_PX * scl * domToCanvas * 2.5;
        ctx.font = fontPx + 'px "Apple Color Emoji", "Segoe UI Emoji", "Noto Color Emoji", "Twemoji", emoji';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText(em.char, 0, 0);
        ctx.restore();
      });

      var stack = [];
      composer.products.forEach(function (p) { stack.push({ kind: 'product', item: p }); });

      return stack.reduce(function (chain, layer) {
        return chain.then(function () {
          // Use chroma-keyed PNG if present + still wanted, else original.
          var src = (layer.kind === 'product'
                      && layer.item.removeWhite !== false
                      && layer.item.processedDataUrl)
                    ? layer.item.processedDataUrl
                    : layer.item.image;
          return loadImage(src).then(function (img) {
            // DOM matches: CSS sets img.width = BASE_PX * scale (height auto).
            // Translate that to canvas coords via domToCanvas. Height follows
            // the source image's natural aspect ratio.
            var scl = (typeof layer.item.scale === 'number' && layer.item.scale > 0) ? layer.item.scale : 1;
            var w = BASE_PX * scl * domToCanvas;
            var ratio = (img.naturalWidth || img.width) / (img.naturalHeight || img.height || 1);
            if (!isFinite(ratio) || ratio <= 0) ratio = 1;
            var h = w / ratio;
            var cx = layer.item.x * CARD_RENDER_W;
            var cy = layer.item.y * CARD_RENDER_H;
            var rot = (typeof layer.item.rotate === 'number') ? layer.item.rotate : 0;
            var maskKey = layer.item.mask || 'square';

            ctx.save();
            ctx.translate(cx, cy);
            if (rot) ctx.rotate(rot * Math.PI / 180);

            // Build mask path in local (centered) coordinates.
            if (maskKey !== 'square') {
              ctx.beginPath();
              if (maskKey === 'circle') {
                var r = Math.min(w, h) / 2;
                ctx.arc(0, 0, r, 0, Math.PI * 2);
              } else if (maskKey === 'rounded') {
                var rx = w * 0.12, ry = h * 0.18;
                var x0 = -w/2, y0 = -h/2;
                if (typeof ctx.roundRect === 'function') {
                  ctx.roundRect(x0, y0, w, h, [Math.min(rx, ry)]);
                } else {
                  var rr = Math.min(rx, ry);
                  ctx.moveTo(x0 + rr, y0);
                  ctx.lineTo(x0 + w - rr, y0);
                  ctx.quadraticCurveTo(x0 + w, y0, x0 + w, y0 + rr);
                  ctx.lineTo(x0 + w, y0 + h - rr);
                  ctx.quadraticCurveTo(x0 + w, y0 + h, x0 + w - rr, y0 + h);
                  ctx.lineTo(x0 + rr, y0 + h);
                  ctx.quadraticCurveTo(x0, y0 + h, x0, y0 + h - rr);
                  ctx.lineTo(x0, y0 + rr);
                  ctx.quadraticCurveTo(x0, y0, x0 + rr, y0);
                }
              } else if (maskKey === 'hexagon' || maskKey === 'star') {
                var pts = (maskKey === 'hexagon')
                  ? [[25,0],[75,0],[100,50],[75,100],[25,100],[0,50]]
                  : [[50,0],[61,35],[98,35],[68,57],[79,91],[50,70],[21,91],[32,57],[2,35],[39,35]];
                pts.forEach(function (pt, i) {
                  var px = (pt[0] / 100) * w - w / 2;
                  var py = (pt[1] / 100) * h - h / 2;
                  if (i === 0) ctx.moveTo(px, py); else ctx.lineTo(px, py);
                });
                ctx.closePath();
              }
              ctx.clip();
            }

            ctx.drawImage(img, -w/2, -h/2, w, h);
            ctx.restore();
          }).catch(function () { /* skip broken layer */ });
        });
      }, Promise.resolve()).then(function () {
        // Drawing layer: flatten on top of background + emojis + products.
        // The drawing canvas's internal resolution matches the master, so a
        // 1:1 drawImage is pixel-accurate.
        if (drawCanvas && drawCanvas.width === CARD_RENDER_W && drawCanvas.height === CARD_RENDER_H) {
          try { ctx.drawImage(drawCanvas, 0, 0, CARD_RENDER_W, CARD_RENDER_H); }
          catch (err) { /* skip if the drawing canvas became unavailable */ }
        }
        return new Promise(function (resolve) {
          canvas.toBlob(function (blob) {
            resolve({ blob: blob, dataUrl: canvas.toDataURL('image/png') });
          }, 'image/png', 0.92);
        });
      });
    });
  }

  function commitComposite() {
    var useBtn = root.querySelector('[data-gcw-composer-use]');
    if (useBtn) { useBtn.disabled = true; useBtn.textContent = 'Rendering...'; }
    composeToBlob().then(function (out) {
      generatedFile = new File([out.blob], 'designer.png', { type: 'image/png' });
      generatedDataUrl = out.dataUrl;
      // Update card preview with composite (replaces the live layered DOM)
      setCardBg(generatedDataUrl);
      // Tear down live layers — composite is now baked
      var layerHost = root.querySelector('[data-gcw-card-layers]');
      if (layerHost) {
        while (layerHost.firstChild) layerHost.removeChild(layerHost.firstChild);
        layerHost.classList.remove('is-active');
      }
      composer.open = false;
      var panelEl = root.querySelector('[data-gcw-composer]');
      var grid = root.querySelector('.gcw__designs');
      if (panelEl) panelEl.hidden = true;
      if (grid) grid.classList.remove('is-hidden-by-composer');
      // Drawing strokes are now baked into the background image; hide the
      // tool UI and clear the live canvas so it doesn't double-paint over
      // the composite preview.
      hideDrawUI();
      if (drawCtx && drawCanvas) drawCtx.clearRect(0, 0, drawCanvas.width, drawCanvas.height);
      // Reset composer working state. The emojis, products, and strokes
      // are now flattened into the composite — keeping them in memory
      // would cause them to re-render on top of the baked image the next
      // time the composer is reopened (the "double-layered" bug).
      // The composite itself is preserved via generatedDataUrl, so the
      // designer tile still selects/restores correctly.
      composer.emojis = [];
      composer.products = [];
      composer.drawingDataUrl = '';
      composer.selectedLayer = null;
      persistComposer();
      if (useBtn) { useBtn.disabled = false; useBtn.textContent = 'Use this design'; }
      // Lock state to designer + advance one step (matches normal pick UX)
      TB.go({ design: 'designer' });
    }).catch(function () {
      if (useBtn) { useBtn.disabled = false; useBtn.textContent = 'Use this design'; }
      var err = root.querySelector('[data-gcw-product-error]');
      if (err) { err.textContent = 'Could not render design. Try again.'; err.hidden = false; }
    });
  }

  // =========================================================
  // Drawing tool layer
  // =========================================================
  // Atrament-style smoothed pen, plus eraser / line / rect / circle. The
  // drawing canvas's internal resolution matches CARD_RENDER_W/H so a 1:1
  // copy onto the master composite at "Use this design" time is pixel-perfect.

  var drawCanvas = null;
  var drawCtx = null;
  var drawState = {
    tool: 'pen',
    color: '#ffffff',
    width: 6,
    drawing: false,
    startX: 0, startY: 0,
    lastX: 0, lastY: 0,
    snapshot: null
  };
  var drawInited = false;

  function pointerToCanvas(e) {
    var rect = drawCanvas.getBoundingClientRect();
    var x = (e.clientX - rect.left) / rect.width * drawCanvas.width;
    var y = (e.clientY - rect.top) / rect.height * drawCanvas.height;
    return { x: x, y: y };
  }

  function persistDrawing() {
    if (!drawCanvas) return;
    try { composer.drawingDataUrl = drawCanvas.toDataURL('image/png'); } catch (e) { /* tainted */ }
    persistComposer();
  }

  function restoreDrawing() {
    if (!composer.drawingDataUrl || !drawCtx) return;
    var img = new Image();
    img.onload = function () {
      drawCtx.clearRect(0, 0, drawCanvas.width, drawCanvas.height);
      drawCtx.drawImage(img, 0, 0, drawCanvas.width, drawCanvas.height);
    };
    img.src = composer.drawingDataUrl;
  }

  function setDrawTool(tool) {
    drawState.tool = tool;
    var btns = root.querySelectorAll('[data-gcw-tool]');
    for (var i = 0; i < btns.length; i++) {
      btns[i].setAttribute('aria-pressed', btns[i].getAttribute('data-gcw-tool') === tool ? 'true' : 'false');
    }
  }
  function setDrawColor(color) {
    drawState.color = color;
    var btns = root.querySelectorAll('[data-gcw-color]');
    for (var i = 0; i < btns.length; i++) {
      btns[i].setAttribute('aria-pressed', btns[i].getAttribute('data-gcw-color') === color ? 'true' : 'false');
    }
  }
  function setDrawWidth(width) {
    drawState.width = width;
    var w = String(width);
    var btns = root.querySelectorAll('[data-gcw-width]');
    for (var i = 0; i < btns.length; i++) {
      btns[i].setAttribute('aria-pressed', btns[i].getAttribute('data-gcw-width') === w ? 'true' : 'false');
    }
  }

  function initDrawCanvas() {
    if (drawInited) return;
    drawCanvas = root.querySelector('[data-gcw-drawing]');
    if (!drawCanvas) return;
    drawCanvas.width = CARD_RENDER_W;
    drawCanvas.height = CARD_RENDER_H;
    drawCtx = drawCanvas.getContext('2d');
    drawCtx.lineCap = 'round';
    drawCtx.lineJoin = 'round';

    drawCanvas.addEventListener('pointerdown', function (e) {
      if (!cardEl || !cardEl.classList.contains('is-drawing')) return;
      e.preventDefault();
      try { drawCanvas.setPointerCapture(e.pointerId); } catch (err) {}
      var p = pointerToCanvas(e);
      drawState.drawing = true;
      drawState.startX = p.x; drawState.startY = p.y;
      drawState.lastX = p.x; drawState.lastY = p.y;

      if (drawState.tool === 'line' || drawState.tool === 'rect' || drawState.tool === 'circle') {
        // Snapshot the canvas; redraw against it on each move for live preview.
        try { drawState.snapshot = drawCtx.getImageData(0, 0, drawCanvas.width, drawCanvas.height); }
        catch (err) { drawState.snapshot = null; }
      } else {
        // pen / eraser
        drawCtx.beginPath();
        drawCtx.strokeStyle = drawState.color;
        drawCtx.lineWidth = drawState.width;
        drawCtx.globalCompositeOperation = drawState.tool === 'eraser' ? 'destination-out' : 'source-over';
        drawCtx.moveTo(p.x, p.y);
      }
    });

    drawCanvas.addEventListener('pointermove', function (e) {
      if (!drawState.drawing) return;
      var p = pointerToCanvas(e);

      if (drawState.tool === 'pen' || drawState.tool === 'eraser') {
        // Atrament-style smoothing: quadratic curve from the previous point,
        // using (lastX, lastY) as the control point and the midpoint of
        // (lastX, lastY) and (p.x, p.y) as the curve endpoint. Re-anchoring
        // beginPath() at the midpoint keeps curve segments continuous.
        var mx = (drawState.lastX + p.x) / 2;
        var my = (drawState.lastY + p.y) / 2;
        drawCtx.quadraticCurveTo(drawState.lastX, drawState.lastY, mx, my);
        drawCtx.stroke();
        drawCtx.beginPath();
        drawCtx.moveTo(mx, my);
        drawState.lastX = p.x;
        drawState.lastY = p.y;
        return;
      }

      // Shape tools: redraw from snapshot, then draw the in-flight shape.
      if (drawState.snapshot) drawCtx.putImageData(drawState.snapshot, 0, 0);
      drawCtx.beginPath();
      drawCtx.strokeStyle = drawState.color;
      drawCtx.lineWidth = drawState.width;
      drawCtx.globalCompositeOperation = 'source-over';

      if (drawState.tool === 'line') {
        drawCtx.moveTo(drawState.startX, drawState.startY);
        drawCtx.lineTo(p.x, p.y);
        drawCtx.stroke();
      } else if (drawState.tool === 'rect') {
        drawCtx.strokeRect(
          drawState.startX, drawState.startY,
          p.x - drawState.startX, p.y - drawState.startY
        );
      } else if (drawState.tool === 'circle') {
        var dx = p.x - drawState.startX;
        var dy = p.y - drawState.startY;
        var r = Math.sqrt(dx * dx + dy * dy);
        drawCtx.arc(drawState.startX, drawState.startY, r, 0, Math.PI * 2);
        drawCtx.stroke();
      }
    });

    var endStroke = function (e) {
      if (!drawState.drawing) return;
      drawState.drawing = false;
      drawCtx.globalCompositeOperation = 'source-over';
      drawState.snapshot = null;
      try { if (e && e.pointerId != null) drawCanvas.releasePointerCapture(e.pointerId); } catch (err) {}
      persistDrawing();
    };
    drawCanvas.addEventListener('pointerup', endStroke);
    drawCanvas.addEventListener('pointerleave', endStroke);
    drawCanvas.addEventListener('pointercancel', function () {
      drawState.drawing = false;
      drawCtx.globalCompositeOperation = 'source-over';
      drawState.snapshot = null;
    });

    drawInited = true;
  }

  function showDrawToggle() {
    var btn = root.querySelector('[data-gcw-draw-toggle]');
    if (btn) btn.hidden = false;
  }
  function hideDrawUI() {
    var btn = root.querySelector('[data-gcw-draw-toggle]');
    var pal = root.querySelector('[data-gcw-draw-tools]');
    if (btn) btn.hidden = true;
    if (pal) pal.hidden = true;
    if (cardEl) cardEl.classList.remove('is-drawing');
  }
  function openDrawTools() {
    initDrawCanvas();
    var btn = root.querySelector('[data-gcw-draw-toggle]');
    var pal = root.querySelector('[data-gcw-draw-tools]');
    if (btn) btn.hidden = true;
    if (pal) pal.hidden = false;
    if (cardEl) cardEl.classList.add('is-drawing');
  }
  function closeDrawTools() {
    var btn = root.querySelector('[data-gcw-draw-toggle]');
    var pal = root.querySelector('[data-gcw-draw-tools]');
    if (pal) pal.hidden = true;
    if (cardEl) cardEl.classList.remove('is-drawing');
    if (btn) btn.hidden = false;
  }
  function clearDrawing() {
    if (!drawCtx) return;
    drawCtx.clearRect(0, 0, drawCanvas.width, drawCanvas.height);
    composer.drawingDataUrl = '';
    persistComposer();
  }

  // ----- Bind controls -----
  TB.bind = function () {
    // Inputs (text, textarea, email, date)
    root.addEventListener('input', function (e) {
      var t = e.target;
      var key = t.getAttribute && t.getAttribute('data-gcw-input');
      if (!key) return;
      var val = t.value;
      // Length cap for message
      if (key === 'msg' && val.length > MSG_MAX) {
        val = val.slice(0, MSG_MAX);
        t.value = val;
      }
      var patch = {}; patch[key] = val;
      // Replace state without pushing history per keystroke
      history.replaceState({}, '', TB.buildUrl(patch));
      // Light re-render: card + cta + counter, no full step swap
      TB.renderCard();
      var counter = root.querySelector('[data-gcw-msg-counter]');
      if (counter && key === 'msg') counter.textContent = val.length + ' / ' + MSG_MAX;
      var mm = root.querySelector('[data-gcw-email-mismatch]');
      if (mm) {
        var s2 = TB.getState();
        var bad = s2.email && s2.emailConfirm && s2.email !== s2.emailConfirm;
        mm.hidden = !bad;
      }
      TB.updateCta();
    });

    // Click delegations
    root.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('[data-gcw-tab],[data-gcw-event],[data-gcw-design],[data-gcw-upload],[data-gcw-designer-open],[data-gcw-composer-close],[data-gcw-composer-type],[data-gcw-bg-upload],[data-gcw-bg-cat],[data-gcw-bg-id],[data-gcw-emoji-cat],[data-gcw-emoji-pick],[data-gcw-product-suggest],[data-gcw-product-add],[data-gcw-result-prev],[data-gcw-result-next],[data-gcw-composer-use],[data-gcw-amount],[data-gcw-qty-dec],[data-gcw-qty-inc],[data-gcw-suggest],[data-gcw-cta],[data-gcw-back],[data-gcw-change],[data-gcw-draw-toggle],[data-gcw-draw-close],[data-gcw-draw-clear],[data-gcw-tool],[data-gcw-color],[data-gcw-width]');
      if (!t) return;

      // Drawing tool palette — handle before more general handlers below.
      if (t.hasAttribute('data-gcw-draw-toggle')) {
        e.preventDefault();
        openDrawTools();
        return;
      }
      if (t.hasAttribute('data-gcw-draw-close')) {
        e.preventDefault();
        closeDrawTools();
        return;
      }
      if (t.hasAttribute('data-gcw-draw-clear')) {
        e.preventDefault();
        clearDrawing();
        return;
      }
      if (t.hasAttribute('data-gcw-tool')) {
        e.preventDefault();
        setDrawTool(t.getAttribute('data-gcw-tool') || 'pen');
        return;
      }
      if (t.hasAttribute('data-gcw-color')) {
        e.preventDefault();
        setDrawColor(t.getAttribute('data-gcw-color') || '#ffffff');
        return;
      }
      if (t.hasAttribute('data-gcw-width')) {
        e.preventDefault();
        var w = parseFloat(t.getAttribute('data-gcw-width')) || 6;
        setDrawWidth(w);
        return;
      }

      // Tabs
      if (t.hasAttribute('data-gcw-tab')) {
        e.preventDefault();
        var which = t.getAttribute('data-gcw-tab');
        var patch = { self: which === 'self' ? '1' : '0' };
        // Clear recipient/from when switching to self
        if (which === 'self') { patch.to = ''; patch.from = ''; }
        history.replaceState({}, '', TB.buildUrl(patch));
        TB.render();
        return;
      }

      // Event (occasion) button
      if (t.hasAttribute('data-gcw-event')) {
        e.preventDefault();
        var ev = t.getAttribute('data-gcw-event');
        history.replaceState({}, '', TB.buildUrl({ event: ev }));
        TB.render();
        return;
      }

      // Design thumb
      if (t.hasAttribute('data-gcw-design')) {
        e.preventDefault();
        var d = t.getAttribute('data-gcw-design');
        history.replaceState({}, '', TB.buildUrl({ design: d }));
        TB.render();
        return;
      }

      // Upload tile — open native file picker. If a file is already chosen,
      // selecting the tile re-asserts the 'custom' design state.
      if (t.hasAttribute('data-gcw-upload')) {
        e.preventDefault();
        var fileInput = root.querySelector('[data-gcw-file]');
        if (uploadedFile) {
          history.replaceState({}, '', TB.buildUrl({ design: 'custom' }));
          TB.render();
        }
        if (fileInput) fileInput.click();
        return;
      }

      // Designer tile — open composer panel
      if (t.hasAttribute('data-gcw-designer-open')) {
        e.preventDefault();
        openComposer();
        return;
      }
      if (t.hasAttribute('data-gcw-composer-close')) {
        e.preventDefault();
        closeComposer();
        return;
      }
      // Composer type filter
      if (t.hasAttribute('data-gcw-composer-type')) {
        e.preventDefault();
        composer.type = t.getAttribute('data-gcw-composer-type') || 'other';
        syncComposerControls();
        persistComposer();
        return;
      }
      // Composer background upload
      if (t.hasAttribute('data-gcw-bg-upload')) {
        e.preventDefault();
        var bgFile = root.querySelector('[data-gcw-bg-file]');
        if (bgFile) bgFile.click();
        return;
      }

      // Background vibe/category filter
      if (t.hasAttribute('data-gcw-bg-cat')) {
        e.preventDefault();
        var cat = t.getAttribute('data-gcw-bg-cat') || 'all';
        composer.bgCategory = BG_CATEGORIES.indexOf(cat) !== -1 ? cat : 'all';
        syncComposerControls();
        persistComposer();
        return;
      }
      // Background pick
      if (t.hasAttribute('data-gcw-bg-id')) {
        e.preventDefault();
        var bid = t.getAttribute('data-gcw-bg-id');
        composer.backgroundId = bid;
        var bg = designerBgForId(bid);
        if (bg && bg.image) setCardBg(bg.image);
        syncComposerControls();
        persistComposer();
        return;
      }
      // Emoji category tab
      if (t.hasAttribute('data-gcw-emoji-cat')) {
        e.preventDefault();
        composer.emojiCategory = t.getAttribute('data-gcw-emoji-cat') || 'hot';
        // Picking a category clears search to keep the two interactions distinct.
        composer.emojiSearch = '';
        var searchInput = root.querySelector('[data-gcw-emoji-search]');
        if (searchInput) searchInput.value = '';
        syncEmojiCategoryButtons();
        renderEmojiGrid();
        return;
      }
      // Emoji tile — append a new emoji layer to the card
      if (t.hasAttribute('data-gcw-emoji-pick')) {
        e.preventDefault();
        var ch = t.getAttribute('data-gcw-emoji-pick');
        if (ch) addEmoji(ch);
        return;
      }
      // Product category/search suggestion
      if (t.hasAttribute('data-gcw-product-suggest')) {
        e.preventDefault();
        var suggestKey = t.getAttribute('data-gcw-product-suggest') || '';
        var query = PRODUCT_SUGGESTIONS[suggestKey] || suggestKey;
        var psi = root.querySelector('[data-gcw-product-search]');
        if (psi) psi.value = query;
        var suggestBtns = root.querySelectorAll('[data-gcw-product-suggest]');
        for (var ps = 0; ps < suggestBtns.length; ps++) suggestBtns[ps].classList.toggle('is-active', suggestBtns[ps] === t);
        searchProducts(query).then(renderProductResults);
        return;
      }

      // Carousel prev/next inside a product result
      if (t.hasAttribute('data-gcw-result-prev') || t.hasAttribute('data-gcw-result-next')) {
        e.preventDefault();
        var rArt = t.closest('.gcw-composer__product-result');
        if (rArt) cycleResultImage(rArt, t.hasAttribute('data-gcw-result-next') ? 1 : -1);
        return;
      }

      // Product — add the currently-displayed carousel image to card
      if (t.hasAttribute('data-gcw-product-add')) {
        e.preventDefault();
        if (t.disabled) return;
        var artic = t.closest('.gcw-composer__product-result');
        if (!artic) return;
        var imgs;
        try { imgs = JSON.parse(artic.getAttribute('data-images') || '[]'); } catch (er) { imgs = []; }
        var idx = parseInt(artic.getAttribute('data-current-index') || '0', 10) || 0;
        var imgUrl = imgs[idx];
        if (!imgUrl) return;
        addProduct({
          handle: artic.getAttribute('data-handle'),
          image: imgUrl,
          title: artic.getAttribute('data-title')
        });
        return;
      }
      // Use this design — flatten to PNG
      if (t.hasAttribute('data-gcw-composer-use')) {
        e.preventDefault();
        commitComposite();
        return;
      }

      // Amount chip
      if (t.hasAttribute('data-gcw-amount')) {
        e.preventDefault();
        var a = t.getAttribute('data-gcw-amount');
        history.replaceState({}, '', TB.buildUrl({ amount: a }));
        TB.render();
        return;
      }

      // Quantity
      if (t.hasAttribute('data-gcw-qty-dec') || t.hasAttribute('data-gcw-qty-inc')) {
        e.preventDefault();
        var q = parseInt(TB.getState().qty, 10) || 1;
        if (t.hasAttribute('data-gcw-qty-dec')) q = Math.max(MIN_QTY, q - 1);
        else q = Math.min(MAX_QTY, q + 1);
        history.replaceState({}, '', TB.buildUrl({ qty: String(q) }));
        TB.syncControls();
        TB.renderCard();
        TB.updateCta();
        return;
      }

      // Suggested message
      if (t.hasAttribute('data-gcw-suggest')) {
        e.preventDefault();
        var msg = t.getAttribute('data-gcw-suggest') || t.textContent.trim();
        if (msg.length > MSG_MAX) msg = msg.slice(0, MSG_MAX);
        history.replaceState({}, '', TB.buildUrl({ msg: msg }));
        TB.render();
        var ta = root.querySelector('[data-gcw-input="msg"]');
        if (ta) ta.value = msg;
        return;
      }

      // CTA
      if (t.hasAttribute('data-gcw-cta')) {
        e.preventDefault();
        if (t.disabled) return;
        if (currentStep === 7) {
          TB.submitToCart();
        } else {
          if (!TB.canAdvance(currentStep, TB.getState())) return;
          var nextN = Math.min(STEPS, currentStep + 1);
          TB.go({ step: String(nextN) });
        }
        return;
      }

      // Back link
      if (t.hasAttribute('data-gcw-back')) {
        e.preventDefault();
        if (currentStep === 1) {
          window.location.href = '/';
          return;
        }
        history.back();
        return;
      }

      // Change link
      if (t.hasAttribute('data-gcw-change')) {
        e.preventDefault();
        var stepN = t.getAttribute('data-gcw-change');
        TB.go({ step: stepN });
        return;
      }
    });

    // File upload (custom design)
    var fileInput = root.querySelector('[data-gcw-file]');
    if (fileInput) {
      fileInput.addEventListener('change', function () {
        var f = fileInput.files && fileInput.files[0];
        if (!f) return;
        var uploadErr = root.querySelector('[data-gcw-upload-error]');
        var uploadBtn = root.querySelector('[data-gcw-upload]');
        var preview = uploadBtn ? uploadBtn.querySelector('.gcw-thumb__img--user') : null;

        function fail(msg) {
          if (uploadErr) { uploadErr.textContent = msg; uploadErr.hidden = false; }
          fileInput.value = '';
        }

        if (ACCEPTED_UPLOAD_TYPES.indexOf(f.type) === -1) {
          return fail('Please choose a JPG, PNG, or WEBP image.');
        }
        if (f.size > MAX_UPLOAD_BYTES) {
          return fail('Image is too large. Max 4MB.');
        }
        if (uploadErr) { uploadErr.textContent = ''; uploadErr.hidden = true; }

        // Revoke any previous object URL to avoid leaking.
        if (uploadedDataUrl && uploadedDataUrl.indexOf('blob:') === 0) {
          try { URL.revokeObjectURL(uploadedDataUrl); } catch (e) {}
        }
        uploadedFile = f;
        uploadedDataUrl = URL.createObjectURL(f);

        if (preview) {
          preview.src = uploadedDataUrl;
          preview.hidden = false;
        }
        if (uploadBtn) uploadBtn.classList.add('has-file');

        history.replaceState({}, '', TB.buildUrl({ design: 'custom' }));
        TB.render();
      });
    }

    // Composer background upload
    var composerBgFileInput = root.querySelector('[data-gcw-bg-file]');
    if (composerBgFileInput) {
      composerBgFileInput.addEventListener('change', function () {
        var f = composerBgFileInput.files && composerBgFileInput.files[0];
        if (!f) return;
        var err = root.querySelector('[data-gcw-product-error]');
        if (ACCEPTED_UPLOAD_TYPES.indexOf(f.type) === -1) {
          if (err) { err.textContent = 'Please choose a JPG, PNG, or WEBP background.'; err.hidden = false; }
          composerBgFileInput.value = '';
          return;
        }
        if (f.size > MAX_UPLOAD_BYTES) {
          if (err) { err.textContent = 'Background is too large. Max 4MB.'; err.hidden = false; }
          composerBgFileInput.value = '';
          return;
        }
        if (err) { err.textContent = ''; err.hidden = true; }
        if (composerBgUploadDataUrl && composerBgUploadDataUrl.indexOf('blob:') === 0) {
          try { URL.revokeObjectURL(composerBgUploadDataUrl); } catch (e) {}
        }
        composerBgUploadDataUrl = URL.createObjectURL(f);
        var rec = {
          id: 'uploaded-bg-' + Date.now(),
          label: 'Uploaded background',
          tags: 'all,uploaded,custom',
          image: composerBgUploadDataUrl
        };
        addDesignerBgTile(rec, true);
        composer.backgroundId = rec.id;
        composer.bgCategory = 'all';
        setCardBg(rec.image);
        syncComposerControls();
        persistComposer();
      });
    }

    // Product search (Storefront API) — debounced
    var productSearchInput = root.querySelector('[data-gcw-product-search]');
    if (productSearchInput) {
      productSearchInput.addEventListener('input', function () {
        var val = productSearchInput.value.trim();
        var suggestBtns = root.querySelectorAll('[data-gcw-product-suggest]');
        for (var ps = 0; ps < suggestBtns.length; ps++) suggestBtns[ps].classList.remove('is-active');
        if (productSearchTimer) clearTimeout(productSearchTimer);
        if (val.length < 2) {
          var host = root.querySelector('[data-gcw-product-results]');
          if (host) while (host.firstChild) host.removeChild(host.firstChild);
          return;
        }
        productSearchTimer = setTimeout(function () {
          searchProducts(val).then(renderProductResults);
        }, 250);
      });
    }

    // Emoji search — re-render grid live, no debounce needed (in-memory bank).
    var emojiSearchInput = root.querySelector('[data-gcw-emoji-search]');
    if (emojiSearchInput) {
      emojiSearchInput.addEventListener('input', function () {
        composer.emojiSearch = emojiSearchInput.value || '';
        renderEmojiGrid();
      });
    }

    // Schedule toggle
    var schedToggle = root.querySelector('[data-gcw-schedule-toggle]');
    if (schedToggle) {
      schedToggle.addEventListener('change', function () {
        var schedBlock = root.querySelector('[data-gcw-schedule-block]');
        if (schedBlock) schedBlock.hidden = !schedToggle.checked;
        if (!schedToggle.checked) {
          history.replaceState({}, '', TB.buildUrl({ date: '' }));
          var di = root.querySelector('[data-gcw-input="date"]');
          if (di) di.value = '';
          TB.updateCta();
        }
      });
    }

    // Keyboard nav for radiogroups (design + amount)
    function keyNav(selector, key) {
      var els = Array.prototype.slice.call(root.querySelectorAll(selector));
      els.forEach(function (el) {
        el.addEventListener('keydown', function (e) {
          if (['ArrowRight','ArrowDown','ArrowLeft','ArrowUp','Home','End'].indexOf(e.key) === -1) return;
          e.preventDefault();
          var idx = els.indexOf(el);
          var next = idx;
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = (idx + 1) % els.length;
          else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = (idx - 1 + els.length) % els.length;
          else if (e.key === 'Home') next = 0;
          else if (e.key === 'End') next = els.length - 1;
          var target = els[next];
          var val = target.getAttribute(key);
          var stateKey = (key === 'data-gcw-design') ? 'design'
                       : (key === 'data-gcw-amount') ? 'amount'
                       : (key === 'data-gcw-event')  ? 'event'
                       : null;
          if (!stateKey) return;
          var patch = {}; patch[stateKey] = val;
          history.replaceState({}, '', TB.buildUrl(patch));
          TB.render();
          target.focus();
        });
      });
    }
    keyNav('[data-gcw-design]', 'data-gcw-design');
    keyNav('[data-gcw-amount]', 'data-gcw-amount');
    keyNav('[data-gcw-event]', 'data-gcw-event');

    // popstate
    window.addEventListener('popstate', function () { TB.render(); });
  };

  // ----- Cart submit -----
  TB.submitToCart = function () {
    if (inflight) return;
    var s = TB.getState();
    var v = variantForAmount(s.amount);
    if (!v) {
      showError('Please pick a gift card amount.');
      return;
    }
    var props = {};
    var emailVal = s.email;
    if (s.self === '1' && !emailVal && initialData.customer_email) emailVal = initialData.customer_email;
    props['Recipient email'] = emailVal;
    props['__shopify_send_gift_card_to_recipient'] = 'true';
    props['__shopify_offset'] = String(new Date().getTimezoneOffset());
    if (s.self !== '1' && s.to && s.to.trim()) props['Recipient name'] = s.to.trim();
    if (s.from && s.from.trim() && s.self !== '1') props['From'] = s.from.trim();
    if (s.date) props['Send on'] = s.date;
    if (s.msg && s.msg.trim()) props['Message'] = s.msg.trim();
    if (s.event) props['Occasion'] = EVENT_NAMES[s.event] || s.event;

    var design = designForId(s.design);
    if (design && design.label && s.design !== 'custom' && s.design !== 'designer') {
      props['Design'] = design.label;
    }
    if (s.design === 'designer') {
      props['Design'] = 'Custom designer composition';
      // Compact audit trail (kept under 1000 chars). Emojis are 1–4 bytes
      // each so a couple dozen fit comfortably; truncate defensively anyway.
      var audit = {
        background: composer.backgroundId || '',
        emojis: composer.emojis.slice(0, 30).map(function (em) {
          return { char: em.char, x: +em.x.toFixed(3), y: +em.y.toFixed(3), rotate: Math.round(em.rotate || 0) };
        }),
        products: composer.products.slice(0, 4).map(function (pr) {
          return { handle: pr.handle, x: +pr.x.toFixed(3), y: +pr.y.toFixed(3) };
        })
      };
      var auditStr = JSON.stringify(audit);
      if (auditStr.length > 1000) auditStr = auditStr.slice(0, 1000);
      props['Designer composition'] = auditStr;
    }

    var qty = parseInt(s.qty, 10) || 1;
    if (qty < MIN_QTY) qty = MIN_QTY; if (qty > MAX_QTY) qty = MAX_QTY;

    inflight = true; TB.updateCta();
    clearError();

    var useMultipart = (s.design === 'custom' && uploadedFile) || (s.design === 'designer' && generatedFile);

    var handleErr = function (err) {
      inflight = false;
      TB.updateCta();
      showError(err && err.message ? err.message : 'Sorry, something went wrong.');
    };
    var handleOk = function () { window.location.href = '/cart'; };
    var checkRes = function (res) {
      if (!res.ok) return res.json().then(function (j) { throw new Error(j && j.description || j.message || 'Could not add to cart.'); });
      return res.json();
    };

    if (useMultipart) {
      var fd = new FormData();
      fd.append('id', String(v.id));
      fd.append('quantity', String(qty));
      Object.keys(props).forEach(function (k) {
        fd.append('properties[' + k + ']', props[k]);
      });
      var fileToSend = (s.design === 'designer' && generatedFile) ? generatedFile : uploadedFile;
      fd.append('properties[Custom design]', fileToSend, fileToSend.name);
      fetch('/cart/add.js', { method: 'POST', body: fd })
        .then(checkRes)
        .then(handleOk)
        .catch(handleErr);
    } else {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: v.id, quantity: qty, properties: props })
      })
        .then(checkRes)
        .then(handleOk)
        .catch(handleErr);
    }
  };

  function showError(msg) {
    if (!errorEl) return;
    errorEl.textContent = msg;
    errorEl.hidden = false;
  }
  function clearError() {
    if (!errorEl) return;
    errorEl.textContent = '';
    errorEl.hidden = true;
  }

  // ----- Init -----
  function init() {
    root = document.querySelector('[data-gcw]');
    if (!root) return;
    panel = root.querySelector('[data-gcw-panel]');
    cardEl = root.querySelector('[data-gcw-card]');
    ctaEl = root.querySelector('[data-gcw-cta]');
    errorEl = root.querySelector('[data-gcw-error]');
    progressEl = root.querySelector('[data-gcw-progress]');

    // Pull variant data
    var vNode = root.querySelector('[data-gcw-variants]');
    if (vNode) {
      try { variantData = JSON.parse(vNode.textContent.trim()) || []; } catch (e) { variantData = []; }
    }
    var dNode = root.querySelector('[data-gcw-designs]');
    if (dNode) {
      try { designData = JSON.parse(dNode.textContent.trim()) || []; } catch (e) { designData = []; }
    }
    var bgNode = root.querySelector('[data-gcw-designer-bgs]');
    if (bgNode) {
      try { designerBgData = JSON.parse(bgNode.textContent.trim()) || []; } catch (e) { designerBgData = []; }
    }

    // Built-in background library (window.GCWBackgrounds). Merge into the
    // same data array as merchant blocks, then render tiles into the
    // composer grid so they show alongside merchant uploads.
    function svgToDataUri(svg) {
      return 'data:image/svg+xml;utf8,' + encodeURIComponent(svg);
    }
    function rankSort(a, b) { return (b.rank || 0) - (a.rank || 0); }
    if (window.GCWBackgrounds && window.GCWBackgrounds.length) {
      var sortedBgs = window.GCWBackgrounds.slice().sort(rankSort);
      var bgGrid = root.querySelector('[data-gcw-bg-grid]');
      // We prepend built-ins before merchant-uploaded blocks. Iterate in reverse
      // so the final DOM still preserves rank order (highest-ranked first).
      sortedBgs.slice().reverse().forEach(function (b) {
        var rec = { id: 'builtin-bg-' + b.id, label: b.label, tags: ((b.tags || '') + ',' + (b.id || '') + ',' + (b.label || '')).toLowerCase(), image: svgToDataUri(b.svg) };
        designerBgData.push(rec);
        if (!bgGrid) return;
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'gcw-composer__bg';
        btn.setAttribute('data-gcw-bg-id', rec.id);
        btn.setAttribute('data-gcw-bg-tags', rec.tags || '');
        btn.setAttribute('aria-label', rec.label);
        btn.setAttribute('aria-checked', 'false');
        btn.innerHTML = b.svg;
        bgGrid.insertBefore(btn, bgGrid.firstChild);
      });
    }

    // Render the emoji picker UI (category tabs + grid) once at init.
    // Search input value is restored from composer state if present.
    renderEmojiCategories();
    renderEmojiGrid();
    var iNode = root.querySelector('[data-gcw-initial]');
    if (iNode) {
      try { initialData = JSON.parse(iNode.textContent.trim()) || initialData; } catch (e) {}
    }

    // TODO (v2): scale + rotate gestures for placed layers (pinch / handles).
    restoreComposer();

    TB.bind();

    // First render: prefill email if self mode and customer is logged in
    var s = TB.getState();
    if (s.self === '1' && !s.email && initialData.customer_email) {
      history.replaceState({}, '', TB.buildUrl({ email: initialData.customer_email, emailConfirm: initialData.customer_email }));
    }

    // Set date min/max attributes
    var dateInput = root.querySelector('[data-gcw-input="date"]');
    if (dateInput) {
      var t = new Date(); t.setHours(0,0,0,0);
      var tomorrow = new Date(t); tomorrow.setDate(tomorrow.getDate() + 1);
      var maxD = new Date(t); maxD.setDate(maxD.getDate() + DATE_MAX_DAYS);
      dateInput.setAttribute('min', tomorrow.toISOString().slice(0,10));
      dateInput.setAttribute('max', maxD.toISOString().slice(0,10));
    }

    TB.render();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
